/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */

!(function (t, e, s, i, o) {
  "use strict";
  function n(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let r = d();
  function a() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = u('[data-section-type*="footer"]')),
      (t.headerHeight = u("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = u("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = u("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }
  function l() {
    document.addEventListener("theme:resize", h), c();
  }
  function c() {
    const {
      windowHeight: t,
      headerHeight: e,
      logoHeight: s,
      footerHeight: i,
      collectionNavHeight: o,
    } = a();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function h() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: s,
        footerHeight: i,
        collectionNavHeight: o,
      } = a(),
      n = d();
    (n !== r || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (r = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function d() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function u(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  function p(t, e) {
    let s;
    return function () {
      if (t) {
        const i = () => t.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, e));
      }
    };
  }
  function m() {
    return (
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      window.innerWidth
    );
  }
  function v() {
    return (
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      window.innerHeight
    );
  }
  function g() {
    return m() >= window.theme.sizes.small;
  }
  function y() {
    return m() < window.theme.sizes.small;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let f = m(),
    b = v();
  let w = window.scrollY,
    S = null,
    E = null,
    L = null,
    k = null,
    A = 0;
  function C(e) {
    setTimeout(() => {
      A && clearTimeout(A),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function T(t) {
    const e = t.detail;
    e ? (A = setTimeout(q, e)) : q();
  }
  function q() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const x = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    );
  };
  function P(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      x(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      x(t, "rte__video-wrapper");
    });
  }
  function M(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const I = "is-loading",
    H = "img.is-loading";
  function O(t, e) {
    e = e || {};
    var s = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = s),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (t.tabIndex = s),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function D(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          (s = window.getComputedStyle(e)),
          "none" === s.display || "hidden" === s.visibility)
        );
        var e, s;
      });
  }
  var B = {};
  function _(t, e) {
    e = e || {};
    var s = D(t),
      i = e.elementToFocus || t,
      o = s[0],
      n = s[s.length - 1];
    F(),
      (B.focusin = function (e) {
        t !== e.target &&
          !t.contains(e.target) &&
          o &&
          o === e.target &&
          o.focus(),
          (e.target !== t && e.target !== n && e.target !== o) ||
            document.addEventListener("keydown", B.keydown);
      }),
      (B.focusout = function () {
        document.removeEventListener("keydown", B.keydown);
      }),
      (B.keydown = function (e) {
        "Tab" === e.code &&
          (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
          (e.target !== t && e.target !== o) ||
            !e.shiftKey ||
            (e.preventDefault(), n.focus()));
      }),
      document.addEventListener("focusout", B.focusout),
      document.addEventListener("focusin", B.focusin),
      O(i, e);
  }
  function F() {
    document.removeEventListener("focusin", B.focusin),
      document.removeEventListener("focusout", B.focusout),
      document.removeEventListener("keydown", B.keydown);
  }
  function $() {
    window.accessibility.lastElement &&
      document.body.classList.contains("is-focused") &&
      setTimeout(() => {
        var t;
        null === (t = window.accessibility.lastElement) ||
          void 0 === t ||
          t.focus();
      });
  }
  var N = Object.freeze({
    __proto__: null,
    forceFocus: O,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        s = document.getElementById(e.slice(1));
      if (s && t.ignore && s.matches(t.ignore)) return !1;
      e && s && O(s, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s)))
              return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", function () {
                O(i, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: D,
    trapFocus: _,
    removeTrapFocus: F,
    autoFocusLastElement: $,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var s,
          i,
          o,
          n = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          r = e.prefix || "a11y",
          a = {
            newWindow: r + "-new-window-message",
            external: r + "-external-message",
            newWindowExternal: r + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            i = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            o = "_blank" === e,
            n = null === s || -1 === s.indexOf("noopener");
          if (o && n) {
            var r = null === s ? "noopener" : s + " noopener";
            t.setAttribute("rel", r);
          }
          i && o
            ? t.setAttribute("aria-describedby", a.newWindowExternal)
            : i
            ? t.setAttribute("aria-describedby", a.external)
            : o && t.setAttribute("aria-describedby", a.newWindow);
        }),
          (s = n),
          (i = document.createElement("ul")),
          (o = Object.keys(s).reduce(function (t, e) {
            return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
          }, "")),
          i.setAttribute("hidden", !0),
          (i.innerHTML = o),
          document.body.appendChild(i);
      }
    },
  });
  const W = 'input[type="search"]',
    R = '[aria-selected="true"] a',
    z = 'button[type="reset"]',
    U = "hidden";
  let V = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(U);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(U)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(U);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(R);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(W).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(W)),
        (this.resetButton = this.querySelector(z)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            p((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
  };
  customElements.define("header-search-form", V);
  const j = '[role="option"]',
    X = '[aria-selected="true"]',
    J = "[data-popular-searches]",
    Y = "predictive-search",
    Q = "[data-predictive-search-results]",
    G = "[data-predictive-search-status]",
    K = 'input[type="search"]',
    Z = "[data-popdown]",
    tt = "[data-predictive-search-live-region-count-value]",
    et = "[data-search-results-groups-wrapper]",
    st = "[data-predictive-search-search-for-text]",
    it = "#shopify-section-predictive-search",
    ot = '[aria-selected="true"] a',
    nt = '[aria-selected="true"] a, button[aria-selected="true"]';
  let rt = class extends V {
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const t = this.getQuery();
      var e;
      (this.searchTerm && t.startsWith(this.searchTerm)) ||
        null === (e = this.querySelector(et)) ||
        void 0 === e ||
        e.remove();
      this.updateSearchForTerm(this.searchTerm, t),
        (this.searchTerm = t),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(ot)) || t.preventDefault();
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(ot);
    }
    onFocus() {
      const t = this.getQuery();
      t.length &&
        (this.searchTerm !== t
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(t) {
      switch (
        (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    updateSearchForTerm(t, e) {
      const s = this.querySelector(st),
        i = null == s ? void 0 : s.innerText;
      if (i) {
        var o;
        if (
          (null === (o = i.match(new RegExp(t, "g"))) || void 0 === o
            ? void 0
            : o.length) > 1
        )
          return;
        const n = i.replace(t, e);
        s.innerText = n;
      }
    }
    switchOption(t) {
      if (!this.getAttribute("open")) return;
      const e = "up" === t,
        s = this.querySelector(X),
        i = Array.from(this.querySelectorAll(j)).filter(
          (t) => null !== t.offsetParent
        );
      let o = 0;
      if (e && !s) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
      if (
        ((this.statusElement.textContent = ""),
        !e && s
          ? (o = n === i.length - 1 ? 0 : n + 1)
          : e && (o = 0 === n ? i.length - 1 : n - 1),
        o === n)
      )
        return;
      const a = i[o];
      a.setAttribute("aria-selected", !0),
        s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const t = this.querySelector(nt);
      t && t.click();
    }
    getSearchResults(t) {
      const e = t.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[e]
          ? this.renderSearchResults(this.cachedResults[e])
          : fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = new Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                const s = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(it).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = s;
                }),
                  this.renderSearchResults(s);
              })
              .catch((t) => {
                if (20 !== (null == t ? void 0 : t.code))
                  throw (this.close(), t);
              });
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(G)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(t) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = t),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(t) {
      (this.predictiveSearchResults.innerHTML = t),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(tt).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0),
        this.predictiveSearchResults.style.setProperty(
          "--full-screen",
          `${window.visualViewport.height}px`
        );
    }
    close(t = !1) {
      this.closeResults(t),
        (this.isOpen = !1),
        this.predictiveSearchResults.style.removeProperty("--full-screen");
    }
    closeResults(t = !1) {
      var e;
      t && ((this.input.value = ""), this.removeAttribute("results"));
      const s = this.querySelector(X);
      s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        null === (e = this.predictiveSearchResults) ||
          void 0 === e ||
          e.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus(),
        this.popularSearches &&
          (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
          this.a11y.trapFocus(this.searchPopdown, {
            elementToFocus: this.input,
          }));
    }
    constructor() {
      var t;
      super(),
        (this.a11y = N),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(Y)),
        (this.cachedResults = {}),
        (this.input = this.querySelector(K)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(Q)),
        (this.searchPopdown = this.closest(Z)),
        (this.popularSearches =
          null === (t = this.searchPopdown) || void 0 === t
            ? void 0
            : t.querySelector(J)),
        (this.searchTerm = "");
    }
  };
  const at = "[data-popout-list]",
    lt = "[data-popout-toggle]",
    ct = "[data-popout-toggle-text]",
    ht = "[data-popout-input]",
    dt = "[data-popout-option]",
    ut = "[data-product-image]",
    pt = "[data-grid-item]",
    mt = "popout-list--visible",
    vt = "is-visible",
    gt = "is-active",
    yt = "select-popout--top",
    ft = "aria-expanded",
    bt = "aria-current",
    wt = "data-value",
    St = "data-popout-toggle-text",
    Et = "submit";
  let Lt = class extends HTMLElement {
      connectedCallback() {
        (this.popoutList = this.querySelector(at)),
          (this.popoutToggle = this.querySelector(lt)),
          (this.popoutToggleText = this.querySelector(ct)),
          (this.popoutInput = this.querySelector(ht)),
          (this.popoutOptions = this.querySelectorAll(dt)),
          (this.productGridItem = this.popoutList.closest(pt)),
          (this.fireSubmitEvent = this.hasAttribute(Et)),
          (this.popupToggleFocusoutEvent = (t) =>
            this.onPopupToggleFocusout(t)),
          (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
          (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
          (this.keyUpEvent = (t) => this.onKeyUp(t)),
          (this.bodyClickEvent = (t) => this.onBodyClick(t)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
      onPopupToggleClick(t) {
        const e = "true" === t.currentTarget.getAttribute(ft);
        if (this.productGridItem) {
          const t = this.productGridItem.querySelector(ut);
          t && t.classList.toggle(vt, !e),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGridItem.getBoundingClientRect().bottom
            )}px`);
        }
        t.currentTarget.setAttribute(ft, !e),
          this.popoutList.classList.toggle(mt),
          this.popupListMaxWidth(),
          this.toggleListPosition(),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      onPopupToggleFocusout(t) {
        this.contains(t.relatedTarget) || this._hideList();
      }
      onPopupListFocusout(t) {
        const e = t.currentTarget.contains(t.relatedTarget);
        this.popoutList.classList.contains(mt) && !e && this._hideList();
      }
      toggleListPosition() {
        const t = "true" === this.querySelector(lt).getAttribute(ft),
          e = window.innerHeight,
          s = this.popoutList.getBoundingClientRect().bottom,
          i = () => {
            this.classList.remove(yt),
              this.popoutList.removeEventListener("transitionend", i);
          };
        t
          ? e < s && this.classList.add(yt)
          : this.popoutList.addEventListener("transitionend", i);
      }
      popupListMaxWidth() {
        this.popoutList.style.setProperty("--max-width", "100vw"),
          requestAnimationFrame(() => {
            this.popoutList.style.setProperty(
              "--max-width",
              `${parseInt(
                document.body.clientWidth -
                  this.popoutList.getBoundingClientRect().left
              )}px`
            );
          });
      }
      popupOptionsClick(t) {
        if ("#" === t.target.closest(dt).attributes.href.value) {
          t.preventDefault();
          const e = t.currentTarget.hasAttribute(wt)
            ? t.currentTarget.getAttribute(wt)
            : "";
          if (
            ((this.popoutInput.value = e),
            this.popoutInput.disabled &&
              this.popoutInput.removeAttribute("disabled"),
            this.fireSubmitEvent)
          )
            this._submitForm(e);
          else {
            const s = t.currentTarget.parentElement,
              i = this.popoutList.querySelector(`.${gt}`),
              o = this.popoutList.querySelector(`[${bt}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              i && (i.classList.remove(gt), s.classList.add(gt)),
              "quantity" != this.popoutInput.name ||
                s.nextSibling ||
                this.classList.add(gt),
              o &&
                o.hasAttribute(`${bt}`) &&
                (o.removeAttribute(`${bt}`),
                t.currentTarget.setAttribute(`${bt}`, "true")),
              "" !== e &&
                ((this.popoutToggleText.innerHTML = e),
                this.popoutToggleText.hasAttribute(St) &&
                  "" !== this.popoutToggleText.getAttribute(St) &&
                  this.popoutToggleText.setAttribute(St, e)),
              this.onPopupToggleFocusout(t),
              this.onPopupListFocusout(t);
          }
        }
      }
      onKeyUp(t) {
        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
      }
      onBodyClick(t) {
        const e = this.contains(t.target);
        this.popoutList.classList.contains(mt) && !e && this._hideList();
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((t) => {
            t.addEventListener("click", (t) => this.popupOptionsClick(t));
          });
      }
      _onFocusOut() {
        this.addEventListener("keyup", this.keyUpEvent),
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          );
      }
      _submitForm() {
        const t = this.closest("form");
        t && t.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(mt),
          this.popoutToggle.setAttribute(ft, !1),
          this.toggleListPosition(),
          document.body.removeEventListener("click", this.bodyClickEvent);
      }
      constructor() {
        super();
      }
    },
    kt = class extends HTMLElement {
      connectedCallback() {
        (this.input = this.querySelector("input")),
          (this.changeEvent = new Event("change", { bubbles: !0 })),
          (this.buttonClickEvent = this.onButtonClick.bind(this)),
          (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
          this.input.addEventListener("change", this.onQuantityChangeEvent),
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
      }
      onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value,
          s =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
        "increase" === s.name && this.input.stepUp(),
          "decrease" === s.name && this.input.stepDown(),
          e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
      }
      onQuantityChange() {
        "updates[]" == this.input.name && this.updateCart();
      }
      updateCart() {
        "" !== this.quantityValue &&
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: { id: this.input.dataset.id, quantity: this.input.value },
            })
          );
      }
      constructor() {
        super();
      }
    };
  const At = "[data-aos]:not(.aos-animate)",
    Ct = "[data-aos-anchor]",
    Tt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    qt = "aos-animate",
    xt = { attributes: !1, childList: !0, subtree: !0 };
  let Pt = [];
  const Mt = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(At),
            i = t.querySelectorAll(Ct);
          s.length &&
            s.forEach((t) => {
              It.observe(t);
            }),
            i.length && Ot(i);
        }
    },
    It = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(qt), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    Ht = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const s = t.target.querySelectorAll(At);
            s.length &&
              s.forEach((t) => {
                t.classList.add(qt);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function Ot(t) {
    t.length &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === Pt.indexOf(e)) {
          const t = document.querySelector(e);
          t && (Ht.observe(t), Pt.push(e));
        }
      });
  }
  const Dt = "[data-deferred-media-button]",
    Bt = "video, model-viewer, iframe",
    _t = '[data-host="youtube"]',
    Ft = '[data-host="vimeo"]',
    $t = "[data-grid-item]",
    Nt = ".shopify-section",
    Wt = "template",
    Rt = "video",
    zt = "product-model",
    Ut = "loaded",
    Vt = "autoplay";
  let jt = class extends HTMLElement {
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(Ut) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(Ut)) {
        const t = this.querySelector(_t),
          e = this.querySelector(Ft),
          s = t || e,
          i = this.querySelector(Rt);
        if (s) {
          let t = this.hovered ? "playVideo" : "pauseVideo",
            i = `{"event":"command","func":"${t}","args":""}`;
          e &&
            ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
            s.contentWindow.postMessage(i, "*"),
            s.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else i && (this.hovered ? i.play() : i.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(Ut))) {
        const e = document.createElement("div"),
          s = this.querySelector(Wt).content.firstElementChild.cloneNode(!0);
        e.appendChild(s), this.setAttribute(Ut, !0);
        const i = this.appendChild(e.querySelector(Bt));
        t && i.focus(),
          "VIDEO" == i.nodeName && i.getAttribute(Vt) && i.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(_t).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(Ft).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(Rt).forEach((t) => t.pause()),
        document.querySelectorAll(zt).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    constructor() {
      super();
      const t = this.querySelector(Dt);
      null == t || t.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(Nt)),
        (this.productGridItem = this.closest($t)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
  };
  const Xt = "is-visible";
  class Jt {
    init() {
      var t;
      const e = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99
            ? t.target.classList.add(Xt)
            : t.target.classList.remove(Xt);
        });
      }, e)),
        null === (t = this.container.querySelectorAll(this.itemSelector)) ||
          void 0 === t ||
          t.forEach((t) => {
            this.observer.observe(t);
          });
    }
    destroy() {
      this.observer.disconnect();
    }
    constructor(t, e) {
      t &&
        e &&
        ((this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init());
    }
  }
  const Yt = "is-dragging",
    Qt = "is-enabled",
    Gt = "is-scrolling",
    Kt = "is-visible",
    Zt = "[data-grid-item]";
  class te {
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        s = this.slider.scrollLeft,
        i = e > 0 ? 1 : -1;
      this.slider.classList.add(Yt, Gt),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== s &&
          (this.velX = this.slider.scrollLeft - s || i);
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(Gt);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(Yt),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      const t = this.slider.querySelector(`${Zt}.${Kt}`);
      if (!t) return;
      const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        s = t.offsetWidth + e,
        i = t.offsetLeft,
        o = this.velX > 0 ? 1 : -1,
        n = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = i - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        o < 0 && this.velX < s && (this.distance -= s * n),
        o > 0 && this.velX < s && (this.distance += s * n),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(Gt),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(Qt),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(Qt);
    }
  }
  const ee = "[data-button-arrow]",
    se = "[data-collection-image]",
    ie = "[data-column-image]",
    oe = "[data-product-image]",
    ne = "[data-grid-item]",
    re = "[data-grid-slider]",
    ae = "data-button-prev",
    le = "data-button-next",
    ce = "align-arrows",
    he = "slider__arrows",
    de = "is-visible",
    ue = "scroll-snap-disabled";
  class pe extends HTMLElement {
    connectedCallback() {
      this.init(), this.addEventListener("theme:grid-slider:init", this.init);
    }
    init() {
      var t;
      (this.slider = this.querySelector(re)),
        (this.slides = this.querySelectorAll(ne)),
        (this.buttons = this.querySelectorAll(ee)),
        this.slider.classList.add(ue),
        this.toggleSlider(),
        document.addEventListener("theme:resize:width", this.toggleSlider),
        ((t = this),
        new Promise((e) => {
          const s = t.querySelectorAll("[data-aos]");
          let i = 0;
          function o(t) {
            i++,
              i === s.length && e(),
              t.target.removeEventListener("animationend", o);
          }
          s.forEach((t) => {
            t.addEventListener("animationend", o);
          });
        })).then(() => {
          this.slider.classList.remove(ue);
        });
    }
    toggleSlider() {
      if (
        !(this.slider.clientWidth < this.getSlidesWidth()) ||
        (!g() && window.theme.touch)
      )
        this.destroy();
      else {
        if (this.isInitialized) return;
        (this.slidesObserver = new Jt(this.slider, ne)),
          this.initArrows(),
          (this.isInitialized = !0),
          (this.draggableSlider = new te(this.slider));
      }
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(he),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.append(t),
          (this.buttons = this.querySelectorAll(ee)),
          (this.buttonPrev = this.querySelector(`[${ae}]`)),
          (this.buttonNext = this.querySelector(`[${le}]`));
      }
      this.toggleArrowsObserver(),
        this.hasAttribute(ce) &&
          (this.positionArrows(), this.arrowsResizeObserver()),
        this.buttons.forEach((t) => {
          t.addEventListener("click", this.onButtonArrowClick);
        });
    }
    buttonArrowClickEvent(t) {
      t.preventDefault();
      const e = this.slider.querySelector(`${ne}.${de}`);
      let s = null;
      t.target.hasAttribute(ae) &&
        (s = null == e ? void 0 : e.previousElementSibling),
        t.target.hasAttribute(le) &&
          (s = null == e ? void 0 : e.nextElementSibling),
        this.goToSlide(s);
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${he}`)) || void 0 === t || t.remove();
    }
    goToSlide(t) {
      t &&
        this.slider.scrollTo({
          top: 0,
          left: t.offsetLeft,
          behavior: "smooth",
        });
    }
    getSlidesWidth() {
      var t;
      return (
        (null === (t = this.slider.querySelector(ne)) || void 0 === t
          ? void 0
          : t.clientWidth) * this.slider.querySelectorAll(ne).length
      );
    }
    toggleArrowsObserver() {
      if (this.buttonPrev && this.buttonNext) {
        const t = this.slides.length,
          e = this.slides[0],
          s = this.slides[t - 1],
          i = { attributes: !0, childList: !1, subtree: !1 },
          o = (t) => {
            for (const i of t)
              if ("attributes" === i.type) {
                const t = i.target,
                  o = Boolean(t.classList.contains(de));
                t == e && (this.buttonPrev.disabled = o),
                  t == s && (this.buttonNext.disabled = o);
              }
          };
        e &&
          s &&
          ((this.firstLastSlidesObserver = new MutationObserver(o)),
          this.firstLastSlidesObserver.observe(e, i),
          this.firstLastSlidesObserver.observe(s, i));
      }
    }
    positionArrows() {
      const t =
        this.slider.querySelector(oe) ||
        this.slider.querySelector(se) ||
        this.slider.querySelector(ie) ||
        this.slider;
      t &&
        this.style.setProperty("--button-position", t.clientHeight / 2 + "px");
    }
    arrowsResizeObserver() {
      document.addEventListener("theme:resize:width", this.positionArrows);
    }
    disconnectedCallback() {
      this.destroy(),
        document.removeEventListener("theme:resize:width", this.toggleSlider);
    }
    destroy() {
      var t, e;
      (this.isInitialized = !1),
        null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
        (this.draggableSlider = null),
        null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
        (this.slidesObserver = null),
        this.removeArrows(),
        document.removeEventListener("theme:resize:width", this.positionArrows);
    }
    constructor() {
      super(),
        (this.isInitialized = !1),
        (this.draggableSlider = null),
        (this.positionArrows = this.positionArrows.bind(this)),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.slidesObserver = null),
        (this.firstLastSlidesObserver = null),
        (this.isDragging = !1),
        (this.toggleSlider = this.toggleSlider.bind(this));
    }
  }
  const me = "time",
    ve = "[data-days]",
    ge = "[data-hours]",
    ye = "[data-minutes]",
    fe = "[data-seconds]",
    be = ".shopify-section",
    we = "[data-countdown-block]",
    Se = "[data-ticker-text]",
    Ee = "data-expiration-behavior",
    Le = "data-clone",
    ke = "show-message",
    Ae = "hidden",
    Ce = "hide-section",
    Te = "show-message";
  let qe = class extends HTMLElement {
    connectedCallback() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.update(), (this.interval = setInterval(this.update, 1e3)));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= s * this.hoursInMs;
      const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= i * this.minutesInMs;
      return {
        days: e,
        hours: s,
        minutes: i,
        seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
      };
    }
    formatDigits(t) {
      return t < 10 && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      var t, e;
      (this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
      this.shouldHideOnComplete) &&
        (null === (t = this.countdownParent) ||
          void 0 === t ||
          t.classList.add(Ae),
        null === (e = this.countdownParent) ||
          void 0 === e ||
          e.dispatchEvent(
            new CustomEvent("theme:countdown:hide", {
              detail: { element: this },
              bubbles: !0,
            })
          ));
      if (this.shouldShowMessage) {
        var s, i;
        if (
          (null === (s = this.classList) || void 0 === s || s.add(ke),
          this.closest(Se).hasAttribute(Le))
        )
          return;
        null === (i = this.countdownParent) ||
          void 0 === i ||
          i.dispatchEvent(
            new CustomEvent("theme:countdown:expire", { bubbles: !0 })
          );
      }
    }
    update() {
      const t = new Date().getTime(),
        e = this.endDate - t;
      e < 1e3 && (this.stopTimer(), this.onComplete());
      const s = this.convertTime(e);
      this.render(s);
    }
    constructor() {
      super(),
        (this.section = this.closest(be)),
        (this.countdownParent = this.closest(we) || this.section),
        (this.expirationBehavior = this.getAttribute(Ee)),
        (this.time = this.querySelector(me)),
        (this.days = this.querySelector(ve)),
        (this.hours = this.querySelector(ge)),
        (this.minutes = this.querySelector(ye)),
        (this.seconds = this.querySelector(fe)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete = this.expirationBehavior === Ce),
        (this.shouldShowMessage = this.expirationBehavior === Te),
        (this.update = this.update.bind(this));
    }
  };
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(Tt);
        t.length &&
          t.forEach((t) => {
            It.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(Ct);
        t.length && Ot(t);
      })(),
      new MutationObserver(Mt).observe(document.body, xt),
      document.addEventListener("shopify:section:unload", (t) => {
        var e;
        const s =
            "#" +
            (null === (e = t.target.querySelector("[data-section-id]")) ||
            void 0 === e
              ? void 0
              : e.id),
          i = Pt.indexOf(s);
        -1 !== i && Pt.splice(i, 1);
      })),
    window.addEventListener(
      "resize",
      p(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          f !== m() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (f = m())),
          b !== v() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (b = v()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > w
                  ? ((E = !0), (S = !1))
                  : t < w
                  ? ((E = !1), (S = !0))
                  : ((S = null), (E = null)),
                  (w = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: S, down: E, position: t },
                      bubbles: !1,
                    })
                  ),
                  S &&
                    !L &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  E &&
                    !k &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (k = E),
                  (L = S);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", C),
        window.addEventListener("theme:scroll:unlock", T);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    c(),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(I) &&
          (t.target.classList.remove(I),
          t.target.parentNode.classList.remove(I),
          t.target.parentNode.parentNode.classList.contains(I) &&
            t.target.parentNode.parentNode.classList.remove(I));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      l(),
        M(document),
        n(document),
        P(document),
        document.querySelectorAll(H).forEach((t) => {
          t.complete &&
            (t.classList.remove(I),
            t.parentNode.classList.remove(I),
            t.parentNode.parentNode.classList.contains(I) &&
              t.parentNode.parentNode.classList.remove(I));
        }),
        document.body.classList.add("is-loaded"),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      n(e), P(e), M(document), l();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Lt),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", kt),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", rt),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", jt),
    customElements.get("grid-slider") ||
      customElements.define("grid-slider", pe),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", qe);
  const xe = (t, e = !1, s = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = s));
  };
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      target: "api-product-grid-item",
      onComplete: null,
    };
    let e = [],
      s = null,
      i = null;
    const o = new Date(),
      n = new Date();
    n.setTime(o.getTime() + 7776e6);
    const r = {
        configuration: {
          expires: n.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = encodeURIComponent(t.join(" "));
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = decodeURIComponent(e).split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            s = e.indexOf(t);
          -1 !== s && (e.splice(s, 1), this.write(e));
        },
      },
      a = (e, s, o, n, l, c) => {
        s.length && e < c
          ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`)
              .then((t) => t.text())
              .then((t) => {
                const i = 100 * e,
                  r = o.id ? `#${o.id}` : "",
                  h = document.createElement("div");
                let d = t;
                (d = d.includes("||itemAnimationDelay||")
                  ? d.replaceAll("||itemAnimationDelay||", i)
                  : d),
                  (d = d.includes("||itemAnimationAnchor||")
                    ? d.replaceAll("||itemAnimationAnchor||", r)
                    : d),
                  (h.innerHTML = d),
                  (o.innerHTML +=
                    h.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  e++,
                  a(e, s, o, n, l, c);
              })
              .catch(() => {
                r.remove(s[0]), s.shift(), a(e, s, o, n, l, c);
              })
          : ((e, s) => {
              xe(e, !0);
              const o = r.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                o &&
                o < i &&
                e.children.length
              ) {
                let t = [],
                  s = [],
                  i = 0;
                for (const e in Shopify.recentlyViewed) {
                  i += 1;
                  const o = Shopify.recentlyViewed[e].split(" "),
                    n = parseInt(e.split("_")[1]);
                  (t = [...t, ...o]),
                    (r.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...o]);
                }
                for (let i = 0; i < e.children.length; i++) {
                  const o = e.children[i];
                  t.length && o.classList.remove(...t),
                    s.length && o.classList.add(...s);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, s);
                } catch (t) {
                  console.log(t);
                }
            })(o, n);
      };
    return {
      showRecentlyViewed: function (o) {
        const n = o || {};
        Object.assign(t, n),
          (e = r.read()),
          (s = document.querySelector(`#${t.wrapperId}`)),
          (i = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && s && a(0, e, s, t.section, t.target, i);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (e) {
        const s = e || {};
        Object.assign(t, s);
        let i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let e = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (e = t.handle);
          const s = i.indexOf(e);
          -1 === s
            ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(e)),
            r.write(i);
        }
      },
      hasProducts: r.read().length > 0,
    };
  })();
  const Pe = "is-focused",
    Me = "[data-skip-content]",
    Ie = 'a[href="#"]';
  window.accessibility = new (class {
    init() {
      (this.a11y = N),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(Me)),
        (this.linkesWithOnlyHash = document.querySelectorAll(Ie)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(Pe);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(Pe);
        });
    }
    constructor() {
      this.init();
    }
  })();
  function He(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let s = "";
    const i = /\{\{\s*(\w+)\s*\}\}/,
      o = e || "${{amount}}";
    function n(t, e = 2, s = ",", i = ".") {
      if (isNaN(t) || null == t) return 0;
      const o = (t = (t / 100).toFixed(e)).split(".");
      return (
        o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) +
        (o[1] ? i + o[1] : "")
      );
    }
    switch (o.match(i)[1]) {
      case "amount":
        s = n(t, 2);
        break;
      case "amount_no_decimals":
        s = n(t, 0);
        break;
      case "amount_with_comma_separator":
        s = n(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        s = n(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        s = n(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        s = n(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        s = n(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        s = n(t, 2, " ", ".");
    }
    return o.replace(i, s);
  }
  const Oe = (t, e) => {
    let s, i;
    return function o(...n) {
      const r = Date.now();
      (i = clearTimeout(i)),
        !s || r - s >= e
          ? (t.apply(null, n), (s = r))
          : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
    };
  };
  function De(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  De.prototype = Error.prototype;
  const Be = "is-animated",
    _e = "is-added",
    Fe = "is-disabled",
    $e = "is-empty",
    Ne = "is-hidden",
    We = "is-hiding",
    Re = "is-loading",
    ze = "is-open",
    Ue = "is-removed",
    Ve = "is-success",
    je = "is-visible",
    Xe = "is-expanded",
    Je = "is-updated",
    Ye = "variant--soldout",
    Qe = "variant--unavailable",
    Ge = "[data-api-content]",
    Ke = "[data-api-line-items]",
    Ze = "[data-api-upsell-items]",
    ts = "[data-api-cart-price]",
    es = "[data-animation]",
    ss = "[data-skip-upsell-product]",
    is = "[data-add-to-cart-bar]",
    os = "[data-cart-error-close]",
    ns = "cart-drawer",
    rs = "[data-cart-drawer-close]",
    as = "[data-cart-empty]",
    ls = "[data-cart-errors]",
    cs = "[data-item-remove]",
    hs = "[data-cart-page]",
    ds = "[data-cart-form]",
    us = "[data-cart-acceptance-checkbox]",
    ps = "[data-cart-checkout-buttons]",
    ms = "[data-cart-checkout-button]",
    vs = "[data-cart-total]",
    gs = "[data-checkout-buttons]",
    ys = "[data-error-message]",
    fs = "[data-close-error]",
    bs = "[data-cart-errors-container]",
    ws = "[data-form-wrapper]",
    Ss = "[data-free-shipping]",
    Es = "[data-progress-graph]",
    Ls = "[data-progress-bar]",
    ks = "[data-header-wrapper]",
    As = "[data-item]",
    Cs = "[data-items-holder]",
    Ts = "[data-left-to-spend]",
    qs = "[data-drawer]",
    xs = "[data-section-id]",
    Ps = "[data-cart-price-holder]",
    Ms = "[data-quick-add-holder]",
    Is = "[data-quick-add-modal]",
    Hs = 'input[name="updates[]"]',
    Os = "[data-upsell-products]",
    Ds = "[data-upsell-widget]",
    Bs = "[data-terms-error-message]",
    _s = "[data-collapsible-body]",
    Fs = "recently-viewed-products-cart",
    $s = "data-cart-total",
    Ns = "disabled",
    Ws = "data-free-shipping",
    Rs = "data-free-shipping-limit",
    zs = "data-item",
    Us = "data-item-index",
    Vs = "data-item-title",
    js = "open",
    Xs = "data-quick-add-holder",
    Js = "data-scroll-locked",
    Ys = "data-upsell-auto-open";
  let Qs = class extends HTMLElement {
    connectedCallback() {
      (this.cartPage = document.querySelector(hs)),
        (this.cartForm = document.querySelector(ds)),
        (this.cartDrawer = document.querySelector(ns)),
        (this.cartEmpty = document.querySelector(as)),
        (this.cartTermsCheckbox = document.querySelector(us)),
        (this.cartCheckoutButtonWrapper = document.querySelector(ps)),
        (this.cartCheckoutButton = document.querySelector(ms)),
        (this.checkoutButtons = document.querySelector(gs)),
        (this.itemsHolder = document.querySelector(Cs)),
        (this.priceHolder = document.querySelector(Ps)),
        (this.items = document.querySelectorAll(As)),
        (this.cartTotal = document.querySelector(vs)),
        (this.freeShipping = document.querySelectorAll(Ss)),
        (this.cartErrorHolder = document.querySelector(ls)),
        (this.cartCloseErrorMessage = document.querySelector(os)),
        (this.headerWrapper = document.querySelector(ks)),
        (this.navDrawer = document.querySelector(qs)),
        (this.upsellProductsHolder = document.querySelector(Os)),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener("theme:cart-drawer:open", this.animateItems),
        document.addEventListener(
          "theme:cart-drawer:close",
          this.onCartDrawerClose
        ),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(Rs)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.formSubmitHandler = Oe(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.animateItems(),
          this.recentlyViewedProducts(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.dispatchEvent(
            new CustomEvent("theme:cart:load", { bubbles: !0 })
          ));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        document.removeEventListener(
          "theme:product:add",
          this.productAddCallback
        ),
        document.removeEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.dispatchEvent(
          new CustomEvent("theme:cart:unload", { bubbles: !0 })
        ),
        document.documentElement.hasAttribute(Js) &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    onCartDrawerClose() {
      var t;
      this.resetAnimatedItems(),
        (null === (t = this.cartDrawer) || void 0 === t
          ? void 0
          : t.classList.contains(ze)) && this.cart.classList.remove(Je),
        this.cartEmpty.classList.remove(Je),
        this.cartErrorHolder.classList.remove(Xe),
        this.cart.querySelectorAll(es).forEach((t) => {
          const e = () => {
            t.classList.remove(We), t.removeEventListener("animationend", e);
          };
          t.classList.add(We), t.addEventListener("animationend", e);
        });
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(As)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(cs).forEach((t) => {
        const e = t.closest(As);
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.classList.contains(Fe) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(Xe);
          });
    }
    cartAddEvent(t) {
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.closest("form");
      i.checkValidity()
        ? ((e = new FormData(i)),
          (null !== i && i.querySelector('[type="file"]')) ||
            (t.preventDefault(), this.addToCart(e, s)))
        : i.reportValidity();
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(us).checked,
        e = document.querySelector(Bs);
      if (t)
        e.classList.remove(Xe), this.cartCheckoutButton.removeAttribute(Ns);
      else {
        if (document.querySelector(Bs).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(Ns, !0),
          e.classList.add(Xe);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(fs);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(je);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(Ge);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(Re);
      const s = null == e ? void 0 : e.closest(Ms);
      e && (e.classList.add(Re), (e.disabled = !0)),
        s && s.classList.add(je),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(Re), (e.disabled = !1)))
              );
            this.cart
              ? (e &&
                  (e.classList.remove(Re),
                  e.classList.add(_e),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(Re);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(Re) : e.classList.add(Ue)),
        this.disableCartButtons();
      const i = this.cart.querySelector(`[${zs}="${t.id}"]`) || e,
        o = (null == i ? void 0 : i.hasAttribute(Us))
          ? parseInt(i.getAttribute(Us))
          : 0,
        n = (null == i ? void 0 : i.hasAttribute(Vs))
          ? i.getAttribute(Vs)
          : null;
      if (0 === o) return;
      const r = { line: o, quantity: s };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              void this.enableCartButtons()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(Hs),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(Re);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${cs}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(Fe), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(Ns, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${cs}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(Fe), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(Ns);
          }),
        this.cart.classList.remove(Re);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(ys).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(Xe, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new De({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      var s;
      if (null !== e) {
        const s = e.closest(xs) || e.closest(Ms) || e.closest(Is);
        let i = null == s ? void 0 : s.querySelector(bs);
        const o = e.closest(Ms);
        if ((o && o.querySelector(bs) && (i = o.querySelector(bs)), i)) {
          let e = `${t.message}: ${t.description}`;
          t.message == t.description && (e = t.message),
            (i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(je),
            this.formErrorsEvents(i);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", {
            detail: { response: t, button: e },
            bubbles: !0,
          })
        );
      }
      const i = null == e ? void 0 : e.closest(Ms);
      i &&
        i.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: i,
            },
          })
        ),
        null === (s = this.cart) || void 0 === s || s.classList.remove(Re);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(is);
      e.push(o),
        (s = o.closest(Ms)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(Re), i || t.classList.add(_e);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, s;
            t.classList.remove(_e);
            (null === (e = t.closest(ws)) || void 0 === e
              ? void 0
              : e.classList.contains(Ye)) ||
              (null === (s = t.closest(ws)) || void 0 === s
                ? void 0
                : s.classList.contains(Qe)) ||
              (t.disabled = !1);
          }),
            null == s || s.classList.remove(je);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cart.classList.toggle($e, !t),
        t ||
          setTimeout(() => {
            _(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(rs),
            });
          }, 100);
    }
    build(t) {
      var e;
      const s = t.querySelector(Ke),
        i = t.querySelector(Ze),
        o = Boolean(null === s && null === i),
        n = t.querySelector(ts),
        r = t.querySelector(vs);
      this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
        o
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = s.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = i.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          s && s.querySelectorAll(As).length
            ? s.querySelectorAll(As).length
            : 0),
        (this.subtotal =
          r && r.hasAttribute($s) ? parseInt(r.getAttribute($s)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : He(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        (null === (e = this.cartDrawer) || void 0 === e
          ? void 0
          : e.classList.contains(ze)) && this.cart.classList.add(Je),
        this.cart.classList.remove(Re),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(es).forEach((t) => {
            t.classList.remove(Be);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        );
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(Hs)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s =
            e.hasAttribute(Ws) && "true" === e.getAttribute(Ws) && t >= 0;
          e.classList.toggle(Ve, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(Ss)),
        !this.freeShipping.length)
      )
        return;
      const t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        s = this.circumference - ((e / 100) * this.circumference) / 2,
        i = He(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
      this.freeShipping.forEach((t) => {
        const o = t.querySelector(Ls),
          n = t.querySelector(Es),
          r = t.querySelector(Ts);
        r && (r.innerHTML = i.replace(".00", "")),
          o && (o.value = e),
          n && n.style.setProperty("--stroke-dashoffset", `${s}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(ss);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest(Ms).getAttribute(Xs);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${Xs}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(Ms),
        e = this.upsellProductsHolder.closest(Ds);
      if (
        e &&
        (e.classList.toggle(Ne, !t.length),
        t.length && !e.hasAttribute(js) && e.hasAttribute(Ys))
      ) {
        e.setAttribute(js, !0);
        const t = e.querySelector(_s);
        t && (t.style.height = "auto");
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(es).forEach((t) => {
        t.classList.remove(Be), t.classList.remove(We);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          null == e ||
            e.querySelectorAll(es).forEach((t) => {
              t.classList.add(Be);
            });
      });
    }
    recentlyViewedProducts() {
      this.cart.querySelector(`#${Fs}`) &&
        Shopify.Products.showRecentlyViewed({
          howManyToShow: 3,
          wrapperId: Fs,
          section: this,
          target: "api-upsell-product",
        });
    }
    constructor() {
      super();
    }
  };
  customElements.get("cart-items") || customElements.define("cart-items", Qs);
  const Gs = "data-cart-count",
    Ks = "data-limit";
  let Zs = class extends HTMLElement {
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(Gs, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"),
          (this.innerText = t);
      }
    }
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(Ks)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
  };
  function ti(t) {
    return new Promise((e) => {
      null == t ||
        t.addEventListener("animationend", function s(i) {
          i.target == t && (t.removeEventListener("animationend", s), e());
        });
    });
  }
  customElements.get("cart-count") || customElements.define("cart-count", Zs);
  const ei = "is-open",
    si = "is-closing",
    ii = "drawer--duplicate",
    oi = "drawer-editor-error",
    ni = {
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerSection: '[data-section-type="cart-drawer"]',
      cartDrawerInner: "[data-cart-drawer-inner]",
      shopifySection: ".shopify-section",
    },
    ri = "data-drawer-underlay";
  let ai = class extends HTMLElement {
    connectedCallback() {
      const t = this.closest(ni.shopifySection);
      if (window.theme.hasCartDrawer) {
        if (!window.Shopify.designMode) return void t.remove();
        {
          const t = document.createElement("div");
          t.classList.add(oi),
            (t.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${oi}`) ||
              this.querySelector(ni.cartDrawerInner).append(t),
            this.classList.add(ii);
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:product:added",
        this.openCartDrawerOnProductAdded
      ),
        document.removeEventListener(
          "theme:cart:toggle",
          this.toggleCartDrawer
        ),
        document.removeEventListener(
          "theme:quick-add:open",
          this.closeCartDrawer
        ),
        document.removeEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        ),
        document.querySelectorAll(ni.cartDrawer).length <= 1 &&
          (window.theme.hasCartDrawer = !1);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      (t.target.querySelector(ni.shopifySection) ||
        t.target.closest(ni.shopifySection) ||
        t.target) === this.cartDrawerSection && this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(ii)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:open", {
            detail: { target: this },
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.classList.add(ei),
        this.observeAdditionalCheckoutButtons(),
        ti(this.cartDrawerInner).then(() => {
          _(this, { elementToFocus: this.querySelector(ni.cartDrawerClose) });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(ei) &&
        (this.classList.add(si),
        this.classList.remove(ei),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })
        ),
        F(),
        $(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        ti(this.cartDrawerInner).then(() => {
          this.classList.remove(si);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(ri) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      const t = this.querySelector(ni.additionalCheckoutButtons);
      if (t) {
        const e = new MutationObserver(() => {
          _(this, { elementToFocus: this.querySelector(ni.cartDrawerClose) }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(ni.cartDrawerClose)),
        (this.cartDrawerInner = this.querySelector(ni.cartDrawerInner)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect =
          this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(ni.shopifySection)),
        this.closeCartEvents();
    }
  };
  customElements.get("cart-drawer") || customElements.define("cart-drawer", ai);
  const li = "[data-collapsible]",
    ci = "[data-collapsible-trigger]",
    hi = "[data-collapsible-body]",
    di = "[data-collapsible-content]",
    ui = "desktop",
    pi = "disabled",
    mi = "mobile",
    vi = "open",
    gi = "single";
  let yi = class extends HTMLElement {
    connectedCallback() {
      this.toggle(),
        document.addEventListener("theme:resize:width", this.toggle),
        this.collapsibles.forEach((t) => {
          const e = t.querySelector(ci),
            s = t.querySelector(hi);
          null == e ||
            e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
            s.addEventListener("transitionend", (e) => {
              e.target === s &&
                ("true" == t.getAttribute(vi) && this.setBodyHeight(s, "auto"),
                "false" == t.getAttribute(vi) &&
                  (t.removeAttribute(vi), this.setBodyHeight(s, "")));
            });
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.toggle);
    }
    toggle() {
      const t = g();
      this.collapsibles.forEach((e) => {
        const s = e.hasAttribute(ui) ? e.getAttribute(ui) : "true",
          i = e.hasAttribute(mi) ? e.getAttribute(mi) : "true",
          o = e.querySelector(hi);
        (t && "true" == s) || (!t && "true" == i)
          ? (e.querySelector(ci).removeAttribute("tabindex"),
            e.removeAttribute(vi),
            e.removeAttribute(pi),
            this.setBodyHeight(o, ""))
          : (e.setAttribute(pi, ""),
            e.setAttribute("open", !0),
            e.querySelector(ci).setAttribute("tabindex", -1));
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector(hi),
        s = t.querySelector(di);
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector(hi),
        s = t.querySelector(di);
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = t.target.closest(li);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(vi) &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute(vi) ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(li)),
        (this.single = this.hasAttribute(gi)),
        (this.toggle = this.toggle.bind(this));
    }
  };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", yi);
  const fi = "details",
    bi = "[data-popdown]",
    wi = "[data-popdown-close]",
    Si = 'input:not([type="hidden"])',
    Ei = "data-popdown-underlay",
    Li = "is-open";
  let ki = class extends HTMLElement {
    connectedCallback() {
      this.popdown.addEventListener(
        "transitionend",
        this.popdownTransitionCallback
      ),
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.popdownContainer.addEventListener(
          "toggle",
          this.detailsToggleCallback
        ),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        (this.classList.contains(Li)
          ? "transform" === t.propertyName &&
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(Si),
            })
          : (this.popdownContainer.removeAttribute("open"),
            this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(Ei)) || this.close();
    }
    open() {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          this.classList.add(Li);
        });
    }
    close() {
      this.classList.remove(Li),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(bi)),
        (this.popdownContainer = this.querySelector(fi)),
        (this.popdownClose = this.querySelector(wi)),
        (this.popdownTransitionCallback =
          this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.a11y = N);
    }
  };
  customElements.define("header-search-popdown", ki);
  const Ai = 'input[type="search"]';
  customElements.define(
    "main-search",
    class extends V {
      setupEventListeners() {
        let t = [];
        this.allSearchInputs.forEach((e) => t.push(e.form)),
          this.input.addEventListener("focus", this.onInputFocus.bind(this)),
          t.length < 2 ||
            (t.forEach((t) =>
              t.addEventListener("reset", this.onFormReset.bind(this))
            ),
            this.allSearchInputs.forEach((t) =>
              t.addEventListener("input", this.onInput.bind(this))
            ));
      }
      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() && this.keepInSync("", this.input);
      }
      onInput(t) {
        const e = t.target;
        this.keepInSync(e.value, e);
      }
      onInputFocus() {
        g() || this.scrollIntoView({ behavior: "smooth" });
      }
      keepInSync(t, e) {
        this.allSearchInputs.forEach((s) => {
          s !== e && (s.value = t);
        });
      }
      constructor() {
        super(),
          (this.allSearchInputs = document.querySelectorAll(Ai)),
          this.setupEventListeners();
      }
    }
  );
  const Ci = "[data-actions]",
    Ti = "[data-content]",
    qi = "[data-button]",
    xi = "data-height",
    Pi = "is-open",
    Mi = "is-enabled";
  let Ii = class extends HTMLElement {
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(Pi);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        Mi,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(xi)),
        (this.content = this.querySelector(Ti)),
        (this.trigger = this.querySelector(qi)),
        (this.actions = this.querySelector(Ci)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", Ii);
  const Hi = ".template-addresses",
    Oi = "#AddressNewForm",
    Di = ".address-new-toggle",
    Bi = ".address-edit-toggle",
    _i = ".address-delete",
    Fi = "data-form-id",
    $i = "data-confirm-message",
    Ni = "#EditAddress",
    Wi = "AddressCountryNew",
    Ri = "AddressProvinceNew",
    zi = "AddressProvinceContainerNew",
    Ui = ".address-country-option",
    Vi = "AddressCountry",
    ji = "AddressProvince",
    Xi = "AddressProvinceContainer",
    Ji = "hidden";
  const Yi = document.querySelector(Hi);
  Yi &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const s = t.querySelectorAll(Di);
          s.length &&
            s.forEach((t) => {
              t.addEventListener("click", function () {
                e.classList.toggle(Ji);
              });
            });
          const i = t.querySelectorAll(Bi);
          i.length &&
            i.forEach((e) => {
              e.addEventListener("click", function () {
                const e = this.getAttribute(Fi);
                t.querySelector(`${Ni}_${e}`).classList.toggle(Ji);
              });
            });
          const o = t.querySelectorAll(_i);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function () {
                const t = this.getAttribute(Fi),
                  e = this.getAttribute($i);
                confirm(e) &&
                  Shopify.postLink(
                    window.theme.routes.addresses_url + "/" + t,
                    { parameters: { _method: "delete" } }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(Wi, Ri, { hideElement: zi }),
          this.section.querySelectorAll(Ui).forEach((t) => {
            const e = t.getAttribute(Fi),
              s = `${Vi}_${e}`,
              i = `${ji}_${e}`,
              o = `${Xi}_${e}`;
            new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
          });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector(Oi)),
          this.init();
      }
    })(Yi);
  const Qi = ".customer-logged-in",
    Gi = ".account",
    Ki = ".account-sidebar--mobile";
  const Zi = document.querySelector(Qi);
  Zi &&
    new (class {
      init() {
        this.section.querySelector(Gi) && this.accountMobileSidebar();
      }
      accountMobileSidebar() {
        this.section.querySelector(Ki) &&
          this.section.querySelector(Ki).addEventListener("click", function () {
            const t = this.nextElementSibling;
            t && "UL" === t.tagName && t.classList.toggle("visible");
          });
      }
      constructor(t) {
        (this.section = t), this.init();
      }
    })(Zi);
  const to = "[data-account-form]",
    eo = "[data-show-reset]",
    so = "[data-hide-reset]",
    io = "[data-recover-password]",
    oo = "[data-recover-success]",
    no = "[data-login-form]",
    ro = "#recover",
    ao = "is-hidden";
  const lo = document.querySelector(to);
  lo &&
    new (class {
      init() {
        window.location.hash == ro || this.recoverSuccess
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.showButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.showRecoverPasswordForm();
            }.bind(this),
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.hideRecoverPasswordForm();
            }.bind(this),
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.login.classList.add(ao),
          this.recover.classList.remove(ao),
          (window.location.hash = ro),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.recover.classList.add(ao),
          this.login.classList.remove(ao),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector(eo)),
          (this.hideButton = t.querySelector(so)),
          (this.recover = t.querySelector(io)),
          (this.recoverSuccess = t.querySelector(oo)),
          (this.login = t.querySelector(no)),
          this.init();
      }
    })(lo),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const co = window.Shopify.theme.sections.registered,
    ho = window.Shopify.theme.sections.instances,
    uo = "data-section-id",
    po = "data-section-type";
  let mo = class {
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const s = { id: this.id, type: this.type, container: this.container };
        e ? t.call(s, e) : t.call(s);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(uo))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              uo +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(uo)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
  };
  function vo(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== co[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const s = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, s] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof s
                ? t.push(s)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(s));
            }
          });
      }
    })(t, e);
    return (co[t] = s), co;
  }
  function go(t, e) {
    (t = bo(t)),
      void 0 === e && (e = document.querySelectorAll("[" + po + "]")),
      (e = wo(e)),
      t.forEach(function (t) {
        const s = co[t];
        void 0 !== s &&
          (e = e.filter(function (e) {
            return (
              !(yo(e).length > 0) &&
              null !== e.getAttribute(po) &&
              (e.getAttribute(po) !== t || (ho.push(new mo(e, s)), !1))
            );
          }));
      });
  }
  function yo(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
    if (t instanceof Element || s instanceof Element)
      wo(t).forEach(function (t) {
        e = e.concat(
          ho.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof s) {
      bo(t).forEach(function (t) {
        e = e.concat(
          ho.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function fo(t) {
    for (var e, s = 0; s < ho.length; s++)
      if (ho[s].id === t) {
        e = ho[s];
        break;
      }
    return e;
  }
  function bo(t) {
    return (
      "*" === t
        ? (t = Object.keys(co))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === mo
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === mo &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function wo(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + uo + '="' + e + '"]');
      null !== s && go(s.getAttribute(po), s);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + uo + '="' + e + '"]');
      "object" == typeof yo(s)[0] &&
        yo(s).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + uo + '="' + e + '"]');
      "object" == typeof yo(s)[0] &&
        yo(s).forEach(function (t) {
          var e = ho
            .map(function (t) {
              return t.id;
            })
            .indexOf(t.id);
          ho.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = fo(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = fo(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = fo(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = fo(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const So = "data-tooltip",
    Eo = "data-tooltip-stop-mouseenter",
    Lo = "tooltip-default",
    ko = "is-visible",
    Ao = "is-hiding";
  let Co = {},
    To = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            e = document.createElement("div");
          (e.className = this.class),
            (e.innerHTML = t),
            document.body.appendChild(e);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(t = !1) {
        const e = document.querySelector(`.${this.class}`);
        if (this.label && e && ((t && !this.tooltip.hasAttribute(Eo)) || !t)) {
          const t = e.querySelector(`.${this.class}__arrow`),
            s = e.querySelector(`.${this.class}__inner`);
          e.querySelector(`.${this.class}__text`).innerHTML = this.label;
          const i = s.offsetWidth,
            o = this.tooltip.getBoundingClientRect(),
            n = o.top,
            r = o.width,
            a = n + o.height + window.scrollY;
          let l = o.left - i / 2 + r / 2;
          const c = 24,
            h = l + i - m() + c;
          h > 0 && (l -= h),
            l < 0 && (l = 0),
            (t.style.left = `${o.left + r / 2}px`),
            e.style.setProperty("--tooltip-top", `${a}px`),
            (s.style.transform = `translateX(${l}px)`),
            e.classList.remove(Ao),
            e.classList.add(ko),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(t, e = !1, s = !1) {
        const i = document.querySelector(`.${this.class}`),
          o = i.classList.contains(ko);
        i &&
          ((e && !this.tooltip.hasAttribute(Eo)) || !e) &&
          (o &&
            (s || t.detail.hideTransition) &&
            (i.classList.add(Ao),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              i.classList.remove(Ao);
            }, this.transitionSpeed))),
          i.classList.remove(ko),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(t, e = {}) {
        (this.tooltip = t),
          this.tooltip.hasAttribute(So) &&
            ((this.label = this.tooltip.getAttribute(So)),
            (this.class = e.class || Lo),
            (this.transitionSpeed = e.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => Oe(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
            this.init());
      }
    };
  const qo = {
    onLoad() {
      Co[this.id] = [];
      this.container.querySelectorAll(`[${So}]`).forEach((t) => {
        Co[this.id].push(new To(t));
      });
    },
    onUnload: function () {
      Co[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  var xo = {};
  const Po = {
    onLoad() {
      xo[this.id] = [];
      this.container
        .querySelectorAll("[data-parallax-wrapper]")
        .forEach((t) => {
          const s = t.querySelector("[data-parallax-img]");
          xo[this.id].push(new e(s, { center: !0, round: !0, frame: t }));
        }),
        window.addEventListener("load", () => {
          xo[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      xo[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  vo("article", [qo, Po]);
  const Mo = "[data-aos]",
    Io = ".collection-item__image",
    Ho = "[data-column-image]",
    Oo = ".flickity-button.next",
    Do = ".flickity-button.previous",
    Bo = "a:not(.btn)",
    _o = ".product-item__image",
    Fo = "[data-slide]",
    $o = "data-slide",
    No = "[data-slider]",
    Wo = "[data-slider-thumb]",
    Ro = {
      arrowPositionMiddle: "data-arrow-position-middle",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    zo = "aos-animate",
    Uo = "desktop",
    Vo = "is-focused",
    jo = "flickity-enabled",
    Xo = "is-initialized",
    Jo = "is-loading",
    Yo = "is-selected",
    Qo = "mobile",
    Go = "single-slide",
    Ko = "js-slider--initialized",
    Zo = {};
  let tn = class {
    init() {
      this.slideshow.classList.add(Jo);
      let t = Fo;
      const e = g(),
        o = `${Fo}:not(.${Qo})`,
        n = `${Fo}:not(.${Uo})`;
      (this.slideshow.querySelectorAll(n).length ||
        this.slideshow.querySelectorAll(o).length) &&
        (t = e ? o : n),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(Go),
          this.slideshow.classList.remove(Jo)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(Xo),
                  this.slideshow.classList.remove(Jo),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              const e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              const s = e.querySelectorAll(Mo);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(zo),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(zo);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new i(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new s(this.slideshow, this.sliderOptions)),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const s = [...t.parentElement.children].indexOf(t);
              this.flkty.select(s);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(Jo);
    }
    slideActions(t = !1) {
      const e = this.slideshow.querySelector(`.${Yo}`);
      if (!e) return;
      const s = e.hasAttribute(Ro.slideTextColor)
          ? e.getAttribute(Ro.slideTextColor)
          : "",
        i = e.querySelector(Bo),
        o = this.slideshow.querySelectorAll(`${Fo} a, ${Fo} button`);
      if (
        (document.body.classList.contains(Vo) &&
          i &&
          this.sliderOptions.groupCells &&
          t &&
          i.focus(),
        o.length &&
          o.forEach((t) => {
            const e = t.closest(Fo);
            if (e) {
              const s = e.classList.contains(Yo) ? 0 : -1;
              t.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(Ro.slideIndex))
      ) {
        const t = parseInt(e.getAttribute(Ro.slideIndex)),
          s = this.container.querySelector(`${Wo}.${Yo}`);
        s && s.classList.remove(Yo), this.sliderThumbs[t].classList.add(Yo);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(Ro.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const t =
          this.slideshow.querySelector(Io) ||
          this.slideshow.querySelector(_o) ||
          this.slideshow.querySelector(Ho);
        if (!t) return;
        (this.slideshow.querySelector(Do).style.top =
          t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(Oo).style.top =
            t.clientHeight / 2 + "px");
      }
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      const e = this.slideshow.querySelector(`[${$o}="${t.detail.blockId}"]`);
      if (!e) return;
      let s = parseInt(e.getAttribute(Ro.slideIndex));
      this.multipleSlides && !this.slideshow.classList.contains(Ko) && (s = 0),
        this.slideshow.classList.add(Yo),
        this.flkty &&
          this.slideshow.classList.contains(jo) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(Yo),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
    constructor(t, e = null) {
      (this.container = t),
        (this.slideshow = e || this.container.querySelector(No)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(Fo)),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderThumbs = this.container.querySelectorAll(Wo)),
            (this.multipleSlides = this.slideshow.hasAttribute(
              Ro.slidesLargeDesktop
            )),
            this.slideshow.hasAttribute(Ro.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(Ro.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
  };
  const en = {
    onLoad() {
      Zo[this.id] = [];
      this.container.querySelectorAll(No).forEach((t) => {
        Zo[this.id].push(new tn(this.container, t));
      });
    },
    onUnload() {
      Zo[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      Zo[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      Zo[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  vo("blog-section", [en]), vo("hero", Po), vo("double", en);
  const sn = (t) => {
    let { stickyHeaderHeight: e } = a();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  let on = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    constructor(t, e, s = 7) {
      const i = new Date(),
        o = new Date();
      o.setTime(i.getTime() + 864e5 * s),
        (this.configuration = {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
  };
  const nn = "[data-newsletter-form]",
    rn = "[data-newsletter-heading]",
    an = "[data-newsletter]",
    ln = "has-success",
    cn = "has-error",
    hn = "hidden",
    dn = "data-cookie-name",
    un = {};
  const pn = {
    onLoad() {
      un[this.id] = [];
      this.container.querySelectorAll(nn).forEach((t) => {
        un[this.id].push(
          new (class {
            init() {
              this.newsletter.addEventListener("submit", this.newsletterSubmit),
                this.showMessage();
            }
            newsletterSubmitEvent(t) {
              this.stopSubmit &&
                (t.preventDefault(),
                t.stopImmediatePropagation(),
                this.removeStorage(),
                this.writeStorage(),
                (this.stopSubmit = !1),
                this.newsletter.submit());
            }
            checkForChallengePage() {
              this.isChallengePage = "/challenge" === window.location.pathname;
            }
            writeStorage() {
              void 0 !== this.sessionStorage &&
                this.sessionStorage.setItem(
                  "newsletter_form_id",
                  this.newsletter.id
                );
            }
            readStorage() {
              this.formID = this.sessionStorage.getItem("newsletter_form_id");
            }
            removeStorage() {
              this.sessionStorage.removeItem("newsletter_form_id");
            }
            showMessage() {
              if ((this.readStorage(), this.newsletter.id === this.formID)) {
                const t = document.getElementById(this.formID),
                  e = t.parentElement.querySelector(rn),
                  s =
                    -1 !==
                    window.location.search.indexOf("?customer_posted=true"),
                  i =
                    -1 !== window.location.search.indexOf("accepts_marketing");
                s
                  ? (t.classList.remove(cn),
                    t.classList.add(ln),
                    e && (e.classList.add(hn), t.classList.remove(hn)),
                    this.popup && this.cookie.write())
                  : i &&
                    (t.classList.remove(ln),
                    t.classList.add(cn),
                    e && (e.classList.add(hn), t.classList.remove(hn))),
                  (s || i) &&
                    window.addEventListener("load", () => {
                      this.scrollToForm(t);
                    });
              }
            }
            scrollToForm(t) {
              const e = t.getBoundingClientRect();
              (e.top >= 0 &&
                e.left >= 0 &&
                e.bottom <= v() &&
                e.right <= m()) ||
                setTimeout(() => {
                  sn(t.getBoundingClientRect().top);
                }, 500);
            }
            unload() {
              this.newsletter.removeEventListener(
                "submit",
                this.newsletterSubmit
              );
            }
            constructor(t) {
              (this.sessionStorage = window.sessionStorage),
                (this.newsletter = t),
                (this.popup = this.newsletter.closest(an)),
                this.popup &&
                  (this.cookie = new on(
                    this.popup.getAttribute(dn),
                    "user_has_closed",
                    null
                  )),
                (this.stopSubmit = !0),
                (this.isChallengePage = !1),
                (this.formID = null),
                this.checkForChallengePage(),
                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                this.isChallengePage || this.init();
            }
          })(t)
        );
      });
    },
    onUnload() {
      un[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  vo("footer", [Po, pn]);
  const mn = "[data-collection-sidebar]",
    vn = "[data-collection-sidebar-slide-out]",
    gn = "[data-collection-sidebar-close]",
    yn = "[data-aria-toggle]",
    fn = "drawer--animated",
    bn = "expanded",
    wn = "no-mobile-animation",
    Sn = "is-focused";
  let En = {};
  vo("collection", [
    en,
    Po,
    {
      onLoad() {
        En[this.id] = new (class {
          init() {
            null !== this.groupTagsButton &&
              (document.addEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.addEventListener(
                "click",
                this.groupTagsButtonClickEvent
              ),
              this.collectionSidebar &&
                setTimeout(() => {
                  this.collectionSidebar.classList.remove(wn);
                }, 1e3),
              new MutationObserver((t) => {
                for (const e of t)
                  "attributes" === e.type &&
                    "true" == e.target.getAttribute("aria-expanded") &&
                    this.showSidebarCallback();
              }).observe(this.groupTagsButton, {
                attributes: !0,
                childList: !1,
                subtree: !1,
              })),
              this.container.addEventListener(
                "keyup",
                function (t) {
                  "Escape" === t.code && this.hideSidebar();
                }.bind(this)
              ),
              this.collectionSidebar &&
                (this.collectionSidebar.addEventListener(
                  "transitionend",
                  () => {
                    this.collectionSidebar.classList.contains(bn) ||
                      this.collectionSidebar.classList.remove(fn);
                  }
                ),
                this.toggleSidebarSlider(),
                this.container.addEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                ));
          }
          showSidebarCallback() {
            const t = this.container.querySelector(vn),
              e = document.documentElement.hasAttribute("data-scroll-locked"),
              s = y();
            this.collectionSidebar.classList.add(fn),
              null === t &&
                !s &&
                e &&
                (this.a11y.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                )),
              (s || null !== t) &&
                (t &&
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: this.collectionSidebar.querySelector(gn),
                  }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ));
          }
          hideSidebar() {
            const t = this.container.querySelector(vn),
              e = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"),
              this.collectionSidebar.classList.remove(bn),
              t && this.a11y.removeTrapFocus(),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
          }
          toggleSidebarSlider() {
            y()
              ? this.hideSidebar()
              : this.collectionSidebar.classList.contains(bn) &&
                this.showSidebarCallback();
          }
          collectionSidebarClose(t) {
            t.preventDefault(),
              this.hideSidebar(),
              document.body.classList.contains(Sn) &&
                this.groupTagsButton &&
                this.groupTagsButton.focus();
          }
          groupTagsButtonClick() {
            document.documentElement.hasAttribute("data-scroll-locked") &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          }
          onUnload() {
            null !== this.groupTagsButton &&
              (document.removeEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.removeEventListener(
                "click",
                this.groupTagsButtonClickEvent
              )),
              this.collectionSidebar &&
                this.container.removeEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.collectionSidebar = this.container.querySelector(mn)),
              (this.groupTagsButton = this.container.querySelector(yn)),
              (this.a11y = N),
              (this.groupTagsButtonClickEvent = (t) =>
                this.groupTagsButtonClick(t)),
              (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
              (this.collectionSidebarCloseEvent = (t) =>
                this.collectionSidebarClose(t)),
              this.init();
          }
        })(this);
      },
      onUnload() {
        En[this.id].onUnload();
      },
    },
    qo,
  ]);
  const Ln = "[data-ticker-scale]",
    kn = "[data-ticker-text]",
    An = "data-clone",
    Cn = "autoplay",
    Tn = "speed",
    qn = "ticker--animated",
    xn = "ticker--unloaded",
    Pn = "ticker__comparitor",
    Mn = 1.63,
    In = 100;
  let Hn = class extends HTMLElement {
    connectedCallback() {
      this.checkWidth(),
        this.addEventListener(
          "theme:ticker:refresh",
          p(() => this.checkWidthEvent(), 50)
        ),
        screen.orientation.addEventListener("change", this.checkWidthEvent),
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }
    checkWidth() {
      this.text = this.querySelector(kn);
      const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
        e = this.clientWidth - t < this.comparitor.clientWidth;
      if (e || this.autoplay) {
        var s;
        this.text.classList.remove(qn);
        const i = this.scale.querySelectorAll(`[${An}]`),
          o = this.autoplay
            ? parseInt((window.innerWidth - t) / this.text.clientWidth)
            : 2;
        if (
          (null == i ||
            i.forEach((t) => {
              t.remove();
            }),
          this.autoplay || e)
        )
          for (let t = 0; t <= o; t++) {
            const t = this.text.cloneNode(!0);
            t.setAttribute(An, ""), this.scale.appendChild(t);
          }
        const n = ((this.text.clientWidth / In) * Number(this.speed)).toFixed(
          2
        );
        this.scale.style.removeProperty("--animation-time"),
          this.scale.style.setProperty("--animation-time", `${n}s`),
          null === (s = this.scale.querySelectorAll(kn)) ||
            void 0 === s ||
            s.forEach((t) => {
              t.classList.add(qn);
            });
      } else {
        this.text.classList.add(qn);
        this.scale.querySelectorAll(`[${An}]`).forEach((t) => {
          t.parentNode.removeChild(t);
        }),
          this.text.classList.remove(qn);
      }
    }
    constructor() {
      super(),
        (this.autoplay = this.hasAttribute(Cn)),
        (this.scale = this.querySelector(Ln)),
        (this.text = this.querySelector(kn)),
        (this.speed = this.hasAttribute(Tn) ? this.getAttribute(Tn) : Mn),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(Pn),
        this.appendChild(this.comparitor),
        this.scale.classList.remove(xn),
        (this.checkWidthEvent = this.checkWidth.bind(this));
    }
  };
  const On = {
      marquee: ".announcement__bar-holder--marquee",
      slide: "[data-slide]",
      slider: "[data-slider]",
      ticker: "ticker-bar",
      tickerSlide: ".announcement__slide",
    },
    Dn = "hidden";
  let Bn = class extends HTMLElement {
    connectedCallback() {
      this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        this.addEventListener("theme:countdown:hide", (t) => {
          if (window.Shopify.designMode) return;
          const e = t.target.closest(On.marquee);
          if (1 === this.slidesCount) {
            this.querySelector(On.ticker).style.display = "none";
          }
          if (e) {
            const e = t.target.closest(On.tickerSlide);
            this.removeTickerText(e);
          } else {
            const e = t.target.closest(On.slide);
            this.removeSlide(e);
          }
        }),
        this.addEventListener("theme:countdown:expire", () => {
          var t;
          null === (t = this.querySelectorAll(On.ticker)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          var t;
          null === (t = this.querySelectorAll(On.tickerBar)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        });
    }
    initSlider() {
      const t = g(),
        e = !t;
      var s, i;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new tn(this, this.querySelector(On.slider))),
        null === (i = this.slider.flkty) || void 0 === i || i.reposition());
    }
    removeSlide(t) {
      var e, s;
      null === (e = this.slider.flkty) || void 0 === e || e.remove(t),
        0 ===
          (null === (s = this.slider.flkty) || void 0 === s
            ? void 0
            : s.cells.length) && this.section.classList.add(Dn);
    }
    removeTickerText(t) {
      const e = t.closest(On.ticker);
      t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider && this.slider.onBlockDeselect(t);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        ),
        this.removeEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.removeEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        });
    }
    constructor() {
      super(),
        (this.slider = this.querySelector(On.slider)),
        (this.enableSlider = g()),
        (this.slidesCount = this.querySelectorAll(On.tickerSlide).length),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
  };
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", Bn),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", Hn);
  const _n = "body",
    Fn = "[data-drawer]",
    $n = "[data-drawer-inner]",
    Nn = "[data-drawer-underlay]",
    Wn = "[data-stagger-animation]",
    Rn = "[data-header-wrapper]",
    zn = "data-drawer-toggle",
    Un = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Vn = "drawer--animated",
    jn = "is-open",
    Xn = "is-closing",
    Jn = "is-focused";
  let Yn = {};
  const Qn = {
      onLoad() {
        Yn[this.id] = [];
        this.container.querySelectorAll(Fn).forEach((t) => {
          Yn[this.id].push(
            new (class {
              connectToggle() {
                this.buttons.forEach((t) => {
                  t.addEventListener("click", () => {
                    this.drawer.dispatchEvent(
                      new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
                    );
                  });
                });
              }
              connectDrawer() {
                this.drawer.addEventListener("theme:drawer:toggle", () => {
                  this.drawer.classList.contains(jn)
                    ? this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:close", { bubbles: !0 })
                      )
                    : this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:open", { bubbles: !0 })
                      );
                }),
                  document.addEventListener(
                    "theme:cart-drawer:open",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              closers() {
                this.wrapper.addEventListener("keyup", (t) => {
                  "Escape" === t.code && this.hideDrawer();
                }),
                  this.underlay.addEventListener("click", () => {
                    this.hideDrawer();
                  });
              }
              showDrawer() {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !0);
                  }),
                  this.drawer.classList.add(jn, Vn),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                  ),
                  this.drawerInner &&
                    this.drawerInner.querySelector(this.btnSelector) &&
                    (F(),
                    ti(this.drawerInner).then(() => {
                      this.drawer.querySelector(Un).focus(),
                        (this.isAnimating = !1),
                        _(this.drawerInner, {
                          elementToFocus: this.drawerInner.querySelector(
                            this.btnSelector
                          ),
                        });
                    })));
              }
              hideDrawer() {
                this.drawer.classList.contains(jn) &&
                  !this.isAnimating &&
                  ((this.isAnimating = !0),
                  this.drawer.classList.add(Xn),
                  this.drawer.classList.remove(jn),
                  F(),
                  this.body.classList.contains(Jn) &&
                    this.buttons.length &&
                    this.buttons[0].focus(),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !1);
                  }),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  ),
                  ti(this.drawerInner).then(() => {
                    this.drawer.classList.remove(Xn, Vn),
                      (this.isAnimating = !1),
                      document.dispatchEvent(
                        new CustomEvent("theme:sliderule:close", {
                          bubbles: !1,
                        })
                      );
                  }));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:cart-drawer:open",
                  this.hideDrawer
                ),
                  document.removeEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.removeEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              constructor(t) {
                (this.isAnimating = !1),
                  (this.drawer = t),
                  (this.drawerWrapper = this.drawer.closest(Fn)),
                  (this.drawerInner = this.drawer.querySelector($n)),
                  (this.underlay = this.drawer.querySelector(Nn)),
                  (this.wrapper = this.drawer.closest(Rn)),
                  (this.key = this.drawer.dataset.drawer),
                  (this.btnSelector = `[${zn}='${this.key}']`),
                  (this.buttons = document.querySelectorAll(this.btnSelector)),
                  (this.staggers = this.drawer.querySelectorAll(Wn)),
                  (this.body = document.querySelector(_n)),
                  (this.showDrawer = this.showDrawer.bind(this)),
                  (this.hideDrawer = this.hideDrawer.bind(this)),
                  this.connectToggle(),
                  this.connectDrawer(),
                  this.closers();
              }
            })(t)
          );
        });
      },
      onUnload() {
        Yn[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Gn = ".page-header",
    Kn = "js__header__stuck",
    Zn = "has-header-sticky",
    tr = "shopify-section-group-header-group",
    er = "data-header-sticky",
    sr = "data-scroll-locked";
  let ir = {};
  const or = {
      onLoad() {
        ir = new (class {
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck &&
                t.detail.position > this.headerOffset &&
                this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains(tr) &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(Gn)) || void 0 === t
                    ? void 0
                    : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add(Kn), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute(sr) ||
              (this.cls.remove(Kn), (this.isStuck = !1));
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.removeEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          constructor(t) {
            var e;
            (this.wrapper = t),
              (this.sticks = this.wrapper.hasAttribute(er)),
              document.body.classList.toggle(Zn, this.sticks),
              this.sticks &&
                ((this.isStuck = !1),
                (this.cls = this.wrapper.classList),
                (this.headerOffset =
                  null === (e = document.querySelector(Gn)) || void 0 === e
                    ? void 0
                    : e.offsetTop),
                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                (this.scrollEvent = (t) => this.onScroll(t)),
                this.listen(),
                this.stickOnLoad());
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof ir.unload && ir.unload();
      },
    },
    nr = "data-hover-disclosure-toggle",
    rr = "[data-hover-disclosure]",
    ar = "[data-top-link]",
    lr = "[data-header-wrapper]",
    cr = "[data-stagger]",
    hr = "[data-stagger-first]",
    dr = "[data-stagger-second]",
    ur = "is-visible",
    pr = "meganav--visible",
    mr = "meganav--is-transitioning";
  let vr = {},
    gr = {};
  const yr = {
      onLoad() {
        (vr[this.id] = []),
          (gr = this.container.querySelectorAll(rr)),
          gr.forEach((t) => {
            vr[this.id].push(
              new (class {
                onBlockSelect(t) {
                  this.disclosure.contains(t.target) && this.showDisclosure(t);
                }
                onBlockDeselect(t) {
                  this.disclosure.contains(t.target) && this.hideDisclosure();
                }
                showDisclosure(t) {
                  t &&
                    t.type &&
                    "mouseenter" === t.type &&
                    this.wrapper.classList.add(mr),
                    this.grandparent
                      ? this.wrapper.classList.add(pr)
                      : this.wrapper.classList.remove(pr),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(ur),
                    this.disclosure.classList.add(ur),
                    this.transitionTimeout &&
                      clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                      this.wrapper.classList.remove(mr);
                    }, 200));
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(ur),
                    this.trigger.classList.remove(ur),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(pr, mr);
                }
                staggerChildAnimations() {
                  this.disclosure.querySelectorAll(cr).forEach((t, e) => {
                    t.style.transitionDelay = 50 * e + 10 + "ms";
                  }),
                    this.disclosure.querySelectorAll(hr).forEach((t, e) => {
                      const s = 100 * e;
                      (t.style.transitionDelay = `${s}ms`),
                        t.parentElement.querySelectorAll(dr).forEach((t, e) => {
                          const i = 20 * (e + 1);
                          t.style.transitionDelay = `${s + i}ms`;
                        });
                    });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (t) {
                      this.disclosure.classList.contains(ur) ||
                        (t.preventDefault(), this.showDisclosure(t));
                    }.bind(this),
                    { passive: !0 }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener("mouseenter", (t) =>
                    this.showDisclosure(t)
                  ),
                    this.link.addEventListener("focus", (t) =>
                      this.showDisclosure(t)
                    ),
                    this.trigger.addEventListener("mouseleave", () =>
                      this.hideDisclosure()
                    ),
                    this.trigger.addEventListener("focusout", (t) => {
                      this.trigger.contains(t.relatedTarget) ||
                        this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (t) => {
                      "Escape" === t.code && this.hideDisclosure();
                    });
                }
                constructor(t) {
                  (this.disclosure = t),
                    (this.wrapper = t.closest(lr)),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(
                      `[${nr}='${this.key}']`
                    )),
                    (this.link = this.trigger.querySelector(ar)),
                    (this.grandparent =
                      this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        vr[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        vr[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    fr = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    br = "is-visible",
    wr = "is-hiding",
    Sr = "is-hidden",
    Er = "is-focused",
    Lr = "is-scrolling";
  let kr = {};
  const Ar = {
      onLoad() {
        kr[this.id] = [];
        this.container.querySelectorAll(fr.slideruleWrappper).forEach((t) => {
          kr[this.id].push(
            new (class {
              clickEvents() {
                this.trigger.addEventListener("click", () => {
                  (this.cachedButton = this.trigger), this.showSliderule();
                }),
                  this.exit.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.hideSliderule();
                    });
                  });
              }
              keyboardEvents() {
                this.sliderule.addEventListener("keyup", (t) => {
                  t.stopPropagation(),
                    "Escape" === t.code && this.hideSliderule();
                });
              }
              trapFocusSliderule(t = !0) {
                const e = t
                  ? this.sliderule.querySelector(this.exitSelector)
                  : this.cachedButton;
                this.accessibility.removeTrapFocus(),
                  e &&
                    this.drawerContent &&
                    this.accessibility.trapFocus(this.drawerContent, {
                      elementToFocus: document.body.classList.contains(Er)
                        ? e
                        : null,
                    });
              }
              hideSliderule(t = !1) {
                const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(fr.sliderulePane, e),
                  this.pane.classList.add(wr),
                  this.sliderule.classList.add(wr);
                const s = t
                    ? `[${fr.dataAnimates}].${Sr}`
                    : `[${fr.dataAnimates}="${e}"]`,
                  i = this.pane.querySelectorAll(s);
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove(Sr);
                  });
                const o = t
                  ? this.pane.querySelectorAll(`.${br}, .${wr}`)
                  : this.children;
                o.forEach((s, i) => {
                  const n = o.length - 1 == i;
                  s.classList.remove(br),
                    t &&
                      (s.classList.remove(wr), this.pane.classList.remove(wr));
                  const r = () => {
                    parseInt(this.pane.getAttribute(fr.sliderulePane)) === e &&
                      this.sliderule.classList.remove(br),
                      this.sliderule.classList.remove(wr),
                      this.pane.classList.remove(wr),
                      n &&
                        (this.accessibility.removeTrapFocus(),
                        t || this.trapFocusSliderule(!1)),
                      s.removeEventListener("animationend", r);
                  };
                  window.theme.settings.enableAnimations
                    ? s.addEventListener("animationend", r)
                    : r();
                });
              }
              showSliderule() {
                let t = null;
                const e = this.sliderule.closest(`.${br}`);
                let s = this.pane;
                e && (s = e),
                  s.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                  s.classList.add(Lr);
                const i = () => {
                  s.scrollTop <= 0
                    ? (s.classList.remove(Lr), t && cancelAnimationFrame(t))
                    : (t = requestAnimationFrame(i));
                };
                (t = requestAnimationFrame(i)),
                  this.sliderule.classList.add(br);
                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                  n = o + 1;
                this.pane.setAttribute(fr.sliderulePane, n);
                const r = this.pane.querySelectorAll(
                  `[${fr.dataAnimates}="${o}"]`
                );
                r.length &&
                  r.forEach((t, e) => {
                    const s = r.length - 1 == e;
                    t.classList.add(wr);
                    const i = () => {
                      t.classList.remove(wr),
                        parseInt(this.pane.getAttribute(fr.sliderulePane)) !==
                          o && t.classList.add(Sr),
                        s && this.trapFocusSliderule(),
                        t.removeEventListener("animationend", i);
                    };
                    window.theme.settings.enableAnimations
                      ? t.addEventListener("animationend", i)
                      : i();
                  });
              }
              closeSliderule() {
                this.pane &&
                  this.pane.hasAttribute(fr.sliderulePane) &&
                  parseInt(this.pane.getAttribute(fr.sliderulePane)) > 0 &&
                  (this.hideSliderule(!0),
                  parseInt(this.pane.getAttribute(fr.sliderulePane)) > 0 &&
                    this.pane.setAttribute(fr.sliderulePane, 0));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:sliderule:close",
                  this.closeSliderule
                );
              }
              constructor(t) {
                (this.sliderule = t), (this.key = this.sliderule.id);
                const e = `[${fr.slideruleOpen}='${this.key}']`;
                (this.exitSelector = `[${fr.slideruleClose}='${this.key}']`),
                  (this.trigger = document.querySelector(e)),
                  (this.exit = document.querySelectorAll(this.exitSelector)),
                  (this.pane = document.querySelector(`[${fr.sliderulePane}]`)),
                  (this.children = this.sliderule.querySelectorAll(
                    fr.children
                  )),
                  (this.drawerContent = document.querySelector(
                    fr.drawerContent
                  )),
                  (this.cachedButton = null),
                  (this.accessibility = N),
                  this.trigger.setAttribute("aria-haspopup", !0),
                  this.trigger.setAttribute("aria-expanded", !1),
                  this.trigger.setAttribute("aria-controls", this.key),
                  (this.closeSliderule = this.closeSliderule.bind(this)),
                  this.clickEvents(),
                  this.keyboardEvents(),
                  document.addEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule
                  );
              }
            })(t)
          );
        });
      },
      onUnload() {
        kr[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Cr = "[data-takes-space-wrapper]",
    Tr = "[data-child-takes-space]",
    qr = "[data-header-desktop]",
    xr = '.navlink[href="#"]',
    Pr = "cart-drawer",
    Mr = "[data-cart-toggle]",
    Ir =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    Hr = "js__header__clone",
    Or = "has-first-section-overlay-header",
    Dr = "js__show__mobile",
    Br = "has-header-transparent",
    _r = "data-header-transparent";
  let Fr = {};
  vo("header", [
    {
      onLoad() {
        Fr = new (class {
          initTicker(t = !1) {
            this.tickerFrames.forEach((e) => {
              new Hn(e, t);
            }),
              (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
              document.addEventListener(
                "theme:resize:width",
                this.tickerResizeEvent
              );
          }
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
                this.resizeObserver.observe(this.wrapper))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
              this.wrapper.classList.add(Dr);
              const { headerHeight: t } = a();
              document.documentElement.style.setProperty(
                "--header-height",
                `${t}px`
              );
            } else this.wrapper.classList.remove(Dr);
          }
          getMinWidth() {
            const t = this.wrapper.cloneNode(!0);
            t.classList.add(Hr), document.body.appendChild(t);
            const e = t.querySelectorAll(Cr);
            let s = 0,
              i = 0;
            return (
              e.forEach((t) => {
                const e = t.querySelectorAll(Tr);
                let o = 0;
                (o =
                  3 === e.length
                    ? (function (t) {
                        let e = [];
                        return (
                          t.forEach((t) => {
                            t.firstElementChild &&
                              e.push(t.firstElementChild.clientWidth);
                          }),
                          e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                          e.reduce((t, e) => t + e)
                        );
                      })(e)
                    : (function (t) {
                        let e = 0;
                        return (
                          t.forEach((t) => {
                            e += t.clientWidth;
                          }),
                          e
                        );
                      })(e)),
                  o > s && ((s = o), (i = 20 * e.length));
              }),
              document.body.removeChild(t),
              s + i
            );
          }
          cartToggleEvent() {
            var t;
            "drawer" === theme.settings.cartType &&
              (null === (t = this.wrapper.querySelectorAll(Mr)) ||
                void 0 === t ||
                t.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    const s = document.querySelector(Pr);
                    s &&
                      (e.preventDefault(),
                      s.dispatchEvent(
                        new CustomEvent("theme:cart-drawer:show")
                      ),
                      (window.accessibility.lastElement = t));
                  });
                }));
          }
          toggleButtonClick(t) {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:toggle", { bubbles: !0 })
              );
          }
          unload() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) ||
                void 0 === t ||
                t.unobserve(this.wrapper)
              : document.removeEventListener("theme:resize", this.checkWidth);
          }
          constructor(t) {
            (this.wrapper = t),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(qr)),
              (this.deadLinks = document.querySelectorAll(xr)),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.cartToggleEvent();
            const e = document.querySelector(Ir);
            document.body.classList.toggle(Br, this.wrapper.hasAttribute(_r)),
              document.body.classList.toggle(Or, e);
          }
        })(this.container);
      },
      onUnload() {
        "function" == typeof Fr.unload && Fr.unload();
      },
    },
    Qn,
    Ar,
    or,
    yr,
  ]),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", Hn);
  const $r = "[data-block-scroll]",
    Nr = "flickity-enabled",
    Wr = {};
  const Rr = {
      onLoad() {
        Wr[this.id] = new (class {
          onBlockSelect(t) {
            const e = this.container.querySelector($r);
            if (e && !e.classList.contains(Nr)) {
              const s = t.srcElement;
              s &&
                e.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        Wr[this.id].onBlockSelect(t);
      },
    },
    zr = "[data-slider-mobile]",
    Ur = "[data-slide]",
    Vr = "[data-slider-thumb]",
    jr = "[data-slider-container]",
    Xr = "[data-popup-container]",
    Jr = "[data-popup-close]",
    Yr = "is-animating",
    Qr = "is-open",
    Gr = "data-slider-thumb",
    Kr = {};
  function Zr() {
    this.entries = [];
  }
  function ta(t, e) {
    ea(t);
    var s = (function (t, e) {
      ea(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var s = [];
      return (
        e.forEach(function (e) {
          for (var i = 0; i < t.options.length; i++) {
            if (
              (t.options[i].name || t.options[i]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              s[i] = e.value;
              break;
            }
          }
        }),
        s
      );
    })(t, e);
    return (function (t, e) {
      return (
        ea(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, s) {
            return t.options[s] === e;
          });
        })[0] || null
      );
    })(t, s);
  }
  function ea(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  vo("look", [
    {
      onLoad() {
        Kr[this.id] = new (class {
          init() {
            this.slider &&
              this.slides.length &&
              this.thumbs.length &&
              (this.popupContainer.addEventListener("transitionend", (t) => {
                t.target == this.popupContainer &&
                  (this.popupContainer.classList.remove(Yr),
                  t.target.classList.contains(Qr)
                    ? this.popupOpenCallback()
                    : this.popupCloseCallback());
              }),
              this.popupContainer.addEventListener("transitionstart", (t) => {
                t.target == this.popupContainer &&
                  this.popupContainer.classList.add(Yr);
              }),
              this.popupClose.forEach((t) => {
                t.addEventListener("click", () => {
                  this.popupContainer.classList.remove(Qr),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    );
                });
              }),
              this.thumbs.forEach((t, e) => {
                t.addEventListener("click", (s) => {
                  s.preventDefault();
                  const i =
                      t.hasAttribute(Gr) && "" !== t.getAttribute(Gr)
                        ? parseInt(t.getAttribute(Gr))
                        : e,
                    o = this.slides[i];
                  if (y()) {
                    const t = parseInt(
                      window.getComputedStyle(this.slider).paddingLeft
                    );
                    this.slider.scrollTo({
                      top: 0,
                      left: o.offsetLeft - t,
                      behavior: "auto",
                    }),
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                      ),
                      this.popupContainer.classList.add(Yr, Qr);
                  } else {
                    let { stickyHeaderHeight: t } = a();
                    const e = o.getBoundingClientRect().top,
                      s = o.offsetHeight / 2,
                      i = window.innerHeight,
                      n = i / 2,
                      r = this.container.querySelector(jr);
                    let l = e + s - n + window.scrollY;
                    if (r) {
                      const e = r.getBoundingClientRect().top + window.scrollY,
                        s = e + r.offsetHeight;
                      l < e ? (l = e - t) : l + i > s && (l = s - i);
                    }
                    window.scrollTo({ top: l, left: 0, behavior: "smooth" });
                  }
                });
              }));
          }
          popupCloseByEvent() {
            this.popupContainer.classList.remove(Qr);
          }
          popupOpenCallback() {
            document.addEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.addEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          popupCloseCallback() {
            document.removeEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.removeEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slider = this.container.querySelector(zr)),
              (this.slides = this.container.querySelectorAll(Ur)),
              (this.thumbs = this.container.querySelectorAll(Vr)),
              (this.popupContainer = this.container.querySelector(Xr)),
              (this.popupClose = this.container.querySelectorAll(Jr)),
              (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
              this.init();
          }
        })(this);
      },
    },
    Rr,
  ]),
    (Zr.prototype.add = function (t, e, s) {
      this.entries.push({ element: t, event: e, fn: s }),
        t.addEventListener(e, s);
    }),
    (Zr.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var sa = '[name="id"]',
    ia = '[name="selling_plan"]',
    oa = '[name^="options"]',
    na = '[name="quantity"]',
    ra = '[name^="properties"]';
  const aa = "data-scrollbar",
    la = "data-scrollbar-slider",
    ca = "data-scrollbar-slide-fullwidth",
    ha = "[data-scrollbar-arrow-prev]",
    da = "[data-scrollbar-arrow-next]",
    ua = "is-hidden",
    pa = 200;
  let ma = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    listen() {
      document.addEventListener("theme:modal:open", () => {
        this.toggleNextArrow();
      }),
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const t =
        (this.scrollbar.hasAttribute(ca)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(t), this.arrowPrev.classList.remove(ua), this.toggleNextArrow();
    }
    goToPrev() {
      const t = this.scrollbar.hasAttribute(ca)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e), this.arrowNext.classList.remove(ua), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        var t;
        null === (t = this.arrowNext) ||
          void 0 === t ||
          t.classList.toggle(
            ua,
            Math.round(
              this.scrollbar.scrollLeft +
                this.scrollbar.getBoundingClientRect().width +
                1
            ) >= this.scrollbar.scrollWidth
          );
      }, pa);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(ua, this.scrollbar.scrollLeft <= 0);
      }, pa);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
    }
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(da)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(ha)),
        this.scrollbar.hasAttribute(aa) && (this.init(), this.listen()),
        this.scrollbar.hasAttribute(la) && this.scrollToVisibleElement();
    }
  };
  const va = "[data-grid-swatch-form]",
    ga = "[data-grid-item]",
    ya = "[data-product-information]",
    fa = "[data-product-image]",
    ba = "[data-swatch-button]",
    wa = "[data-swatch-link]",
    Sa = "[data-swatch-text]",
    Ea = "[data-swatch-template]",
    La = "is-visible",
    ka = "no-events",
    Aa = "swatch",
    Ca = "data-swatch-handle",
    Ta = "data-swatch-label",
    qa = "data-scrollbar",
    xa = "data-swatch-count",
    Pa = "data-tooltip",
    Ma = "data-swatch-variant-name",
    Ia = "data-variant-title",
    Ha = "data-swatch-values";
  let Oa = class extends HTMLElement {
      connectedCallback() {
        this.hasAttribute(Pa) && new To(this);
      }
      constructor() {
        super();
      }
    },
    Da = class extends HTMLElement {
      connectedCallback() {
        (this.handle = this.getAttribute(Ca)),
          (this.productItem = this.closest(ga)),
          (this.productInfo = this.closest(ya)),
          (this.productImage = this.productItem.querySelector(fa)),
          (this.template = document.querySelector(Ea).innerHTML),
          (this.swatchesJSON = this.getSwatchesJSON()),
          (this.swatchesStyle = theme.settings.collectionSwatchStyle);
        const t = this.getAttribute(Ta).trim().toLowerCase();
        (function (t) {
          const e = `${window.theme.routes.root}products/${t}.js`;
          return window
            .fetch(e)
            .then((t) => t.json())
            .catch((t) => {
              console.error(t);
            });
        })(this.handle).then((e) => {
          (this.product = e),
            (this.colorOption = e.options.find(function (e) {
              return e.name.toLowerCase() === t || null;
            })),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
      }
      init() {
        if (
          ((this.innerHTML = ""),
          (this.count = 0),
          (this.limitedCount = 0),
          this.swatches.forEach((t) => {
            let e = null,
              s = !1,
              i = "";
            for (const s of this.product.variants) {
              const o = s.options.includes(t);
              if ((!e && o && (e = s), o && s.featured_media)) {
                (i = s.featured_media.preview_image.src), (e = s);
                break;
              }
            }
            for (const e of this.product.variants) {
              if (e.options.includes(t) && e.available) {
                s = !0;
                break;
              }
            }
            if (e) {
              const r = document.createElement("div");
              r.innerHTML = this.template;
              const a = r.querySelector(ba),
                l = r.querySelector(wa),
                c = r.querySelector(Sa),
                h = this.swatchesJSON[t],
                d = "native" == theme.settings.swatchesType ? h : `var(--${h})`,
                u = e.title.replaceAll('"', "'");
              (a.style = `--animation-delay: ${(100 * this.count) / 1250}s`),
                a.classList.add(`${Aa}-${h}`),
                (a.dataset.tooltip = t),
                (a.dataset.swatchVariant = e.id),
                (a.dataset.swatchVariantName = u),
                (a.dataset.swatchImage = i),
                (a.dataset.variant = e.id),
                a.style.setProperty("--swatch", d),
                (l.href =
                  ((o = this.product.url),
                  (n = e.id),
                  /variant=/.test(o)
                    ? o.replace(/(variant=)[^&]+/, "$1" + n)
                    : /\?/.test(o)
                    ? o.concat("&variant=").concat(n)
                    : o.concat("?variant=").concat(n))),
                (l.dataset.swatch = t),
                (l.disabled = !s),
                (c.innerText = t),
                "limited" != this.swatchesStyle
                  ? (this.innerHTML += r.innerHTML)
                  : this.count <= 4 &&
                    ((this.innerHTML += r.innerHTML), this.limitedCount++),
                this.count++;
            }
            var o, n;
          }),
          (this.swatchCount = this.productInfo.querySelector(`[${xa}]`)),
          (this.swatchElements = this.querySelectorAll(wa)),
          (this.swatchForm = this.productInfo.querySelector(va)),
          (this.hideSwatchesTimer = 0),
          this.swatchCount.hasAttribute(xa))
        ) {
          if (
            "text" == this.swatchesStyle ||
            "text-slider" == this.swatchesStyle
          ) {
            if (
              ((this.swatchCount.innerText = `${this.count} ${
                this.count > 1
                  ? theme.strings.otherColor
                  : theme.strings.oneColor
              }`),
              "text" == this.swatchesStyle)
            )
              return;
            this.swatchCount.addEventListener("mouseenter", () => {
              this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
                this.productInfo.classList.add(ka),
                this.swatchForm.classList.add(La);
            }),
              this.productInfo.addEventListener("mouseleave", () => {
                this.hideSwatchesTimer = setTimeout(() => {
                  this.productInfo.classList.remove(ka),
                    this.swatchForm.classList.remove(La);
                }, 100);
              });
          }
          if (
            (("slider" != this.swatchesStyle && "grid" != this.swatchesStyle) ||
              this.swatchForm.classList.add(La),
            "limited" == this.swatchesStyle)
          ) {
            const t = this.count - this.limitedCount;
            this.swatchForm.classList.add(La),
              t > 0 &&
                (this.innerHTML += `<div class="swatch-limited">+${t}</div>`);
          }
        }
        ("text-slider" != this.swatchesStyle &&
          "slider" != this.swatchesStyle) ||
          (this.hasAttribute(qa) && new ma(this)),
          this.bindSwatchButtonEvents();
      }
      bindSwatchButtonEvents() {
        var t;
        null === (t = this.querySelectorAll(ba)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("mouseenter", this.showVariantImageEvent),
              t.hasAttribute(Pa) && new To(t);
          }),
          this.productItem.addEventListener(
            "mouseleave",
            this.productItemMouseLeaveEvent
          );
      }
      showVariantImage(t) {
        var e;
        const s =
            null === (e = t.target.getAttribute(Ma)) || void 0 === e
              ? void 0
              : e.replaceAll('"', "'"),
          i = this.productImage.querySelectorAll(`[${Ia}]`),
          o = this.productImage.querySelector(`[${Ia}="${s}"]`);
        null == i ||
          i.forEach((t) => {
            t.classList.remove(La);
          }),
          null == o || o.classList.add(La);
      }
      hideVariantImages() {
        var t;
        null === (t = this.productImage.querySelectorAll(`[${Ia}].${La}`)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.classList.remove(La);
          });
      }
      getSwatchesJSON() {
        if (!this.hasAttribute(Ha)) return {};
        const t = this.getAttribute(Ha).split(","),
          e = {};
        return (
          null == t ||
            t.forEach((t) => {
              const [s, i] = t.split(":");
              e[s.trim()] = i.trim();
            }),
          e
        );
      }
      constructor() {
        super(),
          (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
          (this.showVariantImageEvent = (t) => this.showVariantImage(t));
      }
    };
  const Ba = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    _a = "is-visible",
    Fa = "is-fade",
    $a = "no-events",
    Na = "is-active",
    Wa = "data-sibling-cutline",
    Ra = "data-sibling-image",
    za = "data-sibling-link",
    Ua = "data-sibling-price",
    Va = "data-product-link";
  let ja = class extends HTMLElement {
    connectedCallback() {
      (this.product = this.closest(Ba.productGridItem)),
        (this.siblingScrollbar = this.querySelector(Ba.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(Ba.siblingCount)),
        (this.siblingFieldset = this.querySelector(Ba.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(Ba.siblingLink)),
        (this.productInfo = this.closest(Ba.productInfo)),
        (this.productLink = this.closest(Ba.link)),
        (this.hideSwatchesTimer = 0),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        this.initScrollbar(),
        this.siblingFieldset &&
          this.productInfo &&
          (("grid" != this.swatchesStyle &&
            "slider" != this.swatchesStyle &&
            "limited" != this.swatchesStyle) ||
            this.siblingFieldset.classList.add(_a),
          this.siblingCount &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            ))),
        this.siblingLinks.length &&
          new (class {
            init() {
              this.cacheDefaultValues(),
                this.product.addEventListener("mouseleave", () =>
                  this.resetProductValues()
                ),
                this.swatches.forEach((t) => {
                  t.addEventListener("mouseenter", (t) => this.showSibling(t));
                }),
                this.productLinks.length &&
                  this.swatches.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.productLinks[0].click();
                    });
                  });
            }
            cacheDefaultValues() {
              (this.productLinkValue = this.productLinks[0].hasAttribute(Va)
                ? this.productLinks[0].getAttribute(Va)
                : ""),
                (this.productPriceValue = this.productPrice.innerHTML),
                this.productCutline &&
                  (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
              this.product.classList.remove(Na),
                this.productLinkValue &&
                  this.productLinks.forEach((t) => {
                    t.href = this.productLinkValue;
                  }),
                this.productPrice &&
                  (this.productPrice.innerHTML = this.productPriceValue),
                this.productCutline &&
                  this.productCutline &&
                  ((this.productCutline.innerHTML = this.productCutlineValue),
                  (this.productCutline.title = this.productCutlineValue)),
                this.hideSiblingImage();
            }
            showSibling(t) {
              const e = t.target,
                s = e.hasAttribute(za) ? e.getAttribute(za) : "",
                i = e.hasAttribute(Ua) ? e.getAttribute(Ua) : "",
                o = e.hasAttribute(Wa) ? e.getAttribute(Wa) : "",
                n = e.hasAttribute(Ra) ? e.getAttribute(Ra) : "";
              s &&
                this.productLinks.forEach((t) => {
                  t.href = s;
                }),
                i &&
                  (this.productPrice.innerHTML = `<span class="price">${i}</span>`),
                this.productCutline &&
                  (o
                    ? ((this.productCutline.innerHTML = o),
                      (this.productCutline.title = o))
                    : ((this.productCutline.innerHTML = ""),
                      (this.productCutline.title = ""))),
                n && this.showSiblingImage(n);
            }
            showSiblingImage(t) {
              if (!this.productImageSibling) return;
              const e = window.devicePixelRatio || 1,
                s = this.productImage.offsetWidth * e,
                i = 180 * Math.ceil(s / 180),
                n = o.getSizedImageUrl(t, `${i}x`),
                r = this.productImageSibling.querySelector(`[src="${n}"]`),
                a = () => {
                  this.productImageSibling.classList.add(_a),
                    this.productImageSibling
                      .querySelector(`[src="${n}"]`)
                      .classList.add(Fa);
                },
                l = () => {
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove(Fa);
                    }),
                    requestAnimationFrame(a);
                };
              if (r) l();
              else {
                const t = document.createElement("img");
                (t.src = n),
                  this.productCutline &&
                    (t.alt = this.productCutline.innerText),
                  t.addEventListener("load", () => {
                    this.productImageSibling.append(t), l();
                  });
              }
            }
            hideSiblingImage() {
              this.productImageSibling &&
                (this.productImageSibling.classList.remove(_a),
                this.productImageSibling
                  .querySelectorAll("img")
                  .forEach((t) => {
                    t.classList.remove(Fa);
                  }));
            }
            constructor(t, e) {
              (this.swatches = t),
                (this.product = e),
                (this.productLinks = this.product.querySelectorAll(
                  Ba.productLink
                )),
                (this.productCutline = this.product.querySelector(
                  Ba.productCutline
                )),
                (this.productPrice = this.product.querySelector(
                  Ba.productPrice
                )),
                (this.productImage = this.product.querySelector(
                  Ba.productImage
                )),
                (this.productImageSibling = this.product.querySelector(
                  Ba.productImageSibling
                )),
                this.init();
            }
          })(this.siblingLinks, this.product),
        this.querySelectorAll(Ba.tooltip).forEach((t) => {
          new To(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add($a),
        "text" != this.swatchesStyle && this.siblingFieldset.classList.add(_a);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove($a),
          this.siblingFieldset.classList.remove(_a);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new ma(this.siblingScrollbar);
    }
    constructor() {
      super();
    }
  };
  const Xa = "[data-hover-slide]",
    Ja = "[data-hover-slide-touch]",
    Ya = "[data-hover-slider]",
    Qa = "[data-product-link]",
    Ga = ".flickity-prev-next-button";
  let Ka = class extends HTMLElement {
    connectedCallback() {
      window.theme.touch ? this.initTouch() : this.initFlickity();
    }
    disconnectedCallback() {
      this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    initTouch() {
      this.style.setProperty(
        "--slides-count",
        this.querySelectorAll(Ja).length
      ),
        this.slider.addEventListener("scroll", this.handleScroll);
    }
    handleScroll() {
      const t = this.slider.scrollLeft / this.slider.clientWidth;
      this.style.setProperty("--slider-index", t);
    }
    initFlickity() {
      this.querySelectorAll(Xa).length < 2 ||
        ((this.flkty = new s(this.slider, {
          cellSelector: Xa,
          contain: !0,
          wrapAround: !0,
          watchCSS: !0,
          autoPlay: !1,
          draggable: !1,
          pageDots: !1,
          prevNextButtons: !0,
        })),
        this.flkty.pausePlayer(),
        this.addEventListener("mouseenter", () => {
          this.flkty.unpausePlayer();
        }),
        this.addEventListener("mouseleave", () => {
          this.flkty.pausePlayer();
        }),
        this.closest(Qa).addEventListener("click", (t) => {
          t.target.matches(Ga) && t.preventDefault();
        }));
    }
    constructor() {
      super(),
        (this.flkty = null),
        (this.slider = this.querySelector(Ya)),
        (this.handleScroll = this.handleScroll.bind(this));
    }
  };
  const Za = "body",
    tl = "[data-related-section]",
    el = "[data-tabs-holder]",
    sl = "data-tab",
    il = "data-tab-index",
    ol = "[data-aos]",
    nl = "data-block-id",
    rl = "[data-tab]",
    al = ".tab-link",
    ll = ".tab-link__recent",
    cl = ".tab-content",
    hl = "[data-scrollbar]",
    dl = "current",
    ul = "hidden",
    pl = "aos-animate",
    ml = "aos-no-transition",
    vl = "is-focused",
    gl = {};
  const yl = {
    onLoad() {
      gl[this.id] = [];
      this.container.querySelectorAll(el).forEach((t) => {
        gl[this.id].push(
          new (class {
            init() {
              const t = this.container.querySelectorAll(rl);
              this.container.addEventListener("theme:tab:check", () =>
                this.checkRecentTab()
              ),
                this.container.addEventListener("theme:tab:hide", () =>
                  this.hideRelatedTab()
                ),
                t.length &&
                  t.forEach((t) => {
                    const e = parseInt(t.getAttribute(sl)),
                      s = this.container.querySelector(`${cl}-${e}`);
                    t.addEventListener("click", () => {
                      this.tabChange(t, s);
                    }),
                      t.addEventListener("keyup", (e) => {
                        ("Space" !== e.code && "Enter" !== e.code) ||
                          !this.body.classList.contains(vl) ||
                          this.tabChange(t, s);
                      });
                  });
            }
            tabChange(t, e) {
              if (t.classList.contains(dl)) return;
              const s = this.container.querySelector(`${rl}.${dl}`),
                i = this.container.querySelector(`${cl}.${dl}`);
              null == s || s.classList.remove(dl),
                null == i || i.classList.remove(dl),
                t.classList.add(dl),
                e.classList.add(dl),
                t.classList.contains(ul) && e.classList.add(ul),
                this.accessibility.a11y.removeTrapFocus(),
                this.container.dispatchEvent(
                  new CustomEvent("theme:tab:change", { bubbles: !0 })
                ),
                t.dispatchEvent(
                  new CustomEvent("theme:form:sticky", {
                    bubbles: !0,
                    detail: { element: "tab" },
                  })
                ),
                this.animateItems(e);
            }
            animateItems(t, e = !0) {
              const s = t.querySelectorAll(ol);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(pl),
                    e &&
                      (t.classList.add(ml),
                      requestAnimationFrame(() => {
                        t.classList.remove(ml), t.classList.add(pl);
                      }));
                });
            }
            initNativeScrollbar() {
              this.scrollbarHolder.length &&
                this.scrollbarHolder.forEach((t) => {
                  new ma(t);
                });
            }
            checkRecentTab() {
              const t = this.container.querySelector(ll);
              if (t) {
                t.classList.remove(ul);
                const e = parseInt(t.getAttribute(sl)),
                  s = this.container.querySelector(`${cl}[${il}="${e}"]`);
                s && (s.classList.remove(ul), this.animateItems(s, !1)),
                  this.initNativeScrollbar();
              }
            }
            hideRelatedTab() {
              const t = this.container.querySelector(tl);
              if (!t) return;
              const e = t.closest(`${cl}.${dl}`);
              if (!e) return;
              const s = parseInt(e.getAttribute(il)),
                i = this.container.querySelectorAll(rl);
              if (i.length > s) {
                const t = i[s].nextSibling;
                t &&
                  (i[s].classList.add(ul),
                  t.dispatchEvent(new Event("click")),
                  this.initNativeScrollbar());
              }
            }
            onBlockSelect(t) {
              const e = this.container.querySelector(
                `${al}[${nl}="${t.detail.blockId}"]`
              );
              e &&
                (e.dispatchEvent(new Event("click")),
                e.parentNode.scrollTo({
                  top: 0,
                  left: e.offsetLeft - e.clientWidth,
                  behavior: "smooth",
                }));
            }
            constructor(t) {
              (this.container = t),
                (this.body = document.querySelector(Za)),
                (this.accessibility = window.accessibility),
                this.container &&
                  ((this.scrollbarHolder = this.container.querySelectorAll(hl)),
                  this.init(),
                  this.initNativeScrollbar());
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      gl[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  function fl() {
    const t = Boolean(
        document.querySelectorAll("dialog[open][data-scroll-lock-required]")
          .length
      ),
      e = Boolean(document.querySelectorAll(".drawer.is-open").length);
    return t || e;
  }
  const bl = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    wl = 3e3,
    Sl = "[data-animation]",
    El = "[data-api-content]",
    Ll = "[data-quick-add-btn]",
    kl = "[data-add-to-cart]",
    Al = "cart-drawer",
    Cl = "[data-cart-page]",
    Tl = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    ql = "[data-message-error]",
    xl = "[data-quick-add-modal-handle]",
    Pl = "[data-product-upsell-ajax]",
    Ml = "[data-quick-add-modal-close]",
    Il = "data-grid-item",
    Hl = "[data-product-information]",
    Ol = "[data-quick-add-holder]",
    Dl = "[data-quick-add-modal]",
    Bl = "[data-quick-add-modal-template]",
    _l = "[data-tooltip]",
    Fl = "closing",
    $l = "data-product-id",
    Nl = "data-quick-add-modal-handle",
    Wl = "data-sibling-swapper",
    Rl = "data-quick-add-holder";
  let zl = class extends HTMLElement {
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.cart &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.accessibility.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(Wl),
        s = this.modalButton.classList.contains(bl.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(bl.loading),
        (this.modalButton.disabled = !0),
        e &&
          !s &&
          ((this.currentModal = t.target.closest(Dl)),
          this.currentModal.classList.add(bl.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${Dl}[${$l}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(Bl);
        if (!e) return;
        const s = document.createElement("div");
        (s.innerHTML = e.innerHTML),
          document.body.appendChild(s.querySelector(Dl)),
          e.remove(),
          (this.modal = document.querySelector(
            `${Dl}[${$l}="${this.productId}"]`
          )),
          (this.modal.querySelector(Pl).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(El).innerHTML),
          this.modal.querySelectorAll(_l).forEach((t) => {
            new To(t);
          }),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", { bubbles: !1 })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(bl.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(bl.loading),
          (this.modalButton.disabled = !1),
          (window.accessibility.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(Sl).forEach((t) => {
            t.classList.add(bl.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(Fl))
          return this.modal.setAttribute(Fl, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(Fl),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(bl.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(bl.disabled) &&
            this.quickAddHolder.classList.remove(bl.disabled),
          this.resetAnimatedItems(),
          fl() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(Ml)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(Fl)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(Tl);
                  null == t || t.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(bl.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${Il}]`);
        if (!s) return;
        const i = e.querySelector(ql),
          o = s.classList.contains(bl.overlayText),
          n = s.querySelector(Hl),
          r = e.querySelector(kl);
        r &&
          (r.classList.remove(bl.added, bl.loading), e.classList.add(bl.error)),
          i && (i.innerText = t.detail.description),
          o && n.classList.add(bl.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), o && n.classList.remove(bl.hidden);
          }, wl);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(bl.visible, bl.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(bl.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), P(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new De({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(Sl).forEach((t) => {
          t.classList.remove(bl.animated);
        });
    }
    constructor() {
      var t;
      (super(),
      (this.container = this),
      (this.cart = document.querySelector(Al) || document.querySelector(Cl)),
      (this.quickAddHolder = this.container.querySelector(Ol)),
      this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(Rl)),
        (this.modalButton = this.quickAddHolder.querySelector(xl)),
        (this.handle =
          null === (t = this.modalButton) || void 0 === t
            ? void 0
            : t.getAttribute(Nl)),
        (this.cartDrawer = document.querySelector(Al)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(Ll)),
        (this.buttonATC = this.quickAddHolder.querySelector(kl)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded =
          this.modalCloseOnProductAdded.bind(this)),
        (this.a11y = N),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  vo("product-grid", [yl]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", zl),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Oa),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", Da),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", ja),
    customElements.get("hover-images") ||
      customElements.define("hover-images", Ka);
  const Ul = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
    Vl = 'input[type="email"]',
    jl = 'input[type="checkbox"]',
    Xl = "[data-form-wrapper]";
  let Jl = class extends HTMLElement {
    connectedCallback() {
      this.fieldCheckbox &&
        (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
        this.form &&
          this.form.addEventListener("theme:product:add", () => {
            (this.fieldCheckbox.checked = !1),
              this.fieldCheckbox.dispatchEvent(new Event("change"));
          }));
    }
    clearInputValues() {
      this.fields.length &&
        this.fields.forEach((t) => {
          t.value = "";
        });
    }
    onChange(t) {
      (this.fieldEmail.required = Boolean(t.target.checked)),
        t.target.checked || this.clearInputValues();
    }
    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
    }
    constructor() {
      super(),
        (this.fieldCheckbox = this.querySelector(jl)),
        (this.fieldEmail = this.querySelector(Vl)),
        (this.fields = this.querySelectorAll(Ul)),
        (this.form = this.closest(Xl)),
        (this.onChangeEvent = (t) => this.onChange(t));
    }
  };
  const Yl = ".product__page",
    Ql = "[data-form-wrapper]",
    Gl = "[data-header-sticky]",
    Kl = "[data-product-media-list]",
    Zl = "is-sticky",
    tc = "data-sticky-enabled";
  window.theme.variables = { productPageSticky: !1 };
  const ec = {};
  const sc = {
      onLoad() {
        ec[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.formWrapper.addEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          stickyFormEvents(t) {
            this.removeAnimationFrameSticky(),
              (this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition(t)
              ));
          }
          scrollEvents(t) {
            (this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents(t) {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.formWrapper.removeEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              this.initSticky();
          }
          stickyScrollCheck() {
            const t = this.container.querySelector(`${Yl} ${Ql}`);
            if (t)
              if (g()) {
                const e = this.container.querySelector(Ql),
                  s = this.container.querySelector(Kl);
                if (!e || !s) return;
                e.offsetHeight < s.offsetHeight
                  ? ((theme.variables.productPageSticky = !0),
                    t.classList.add(Zl))
                  : ((theme.variables.productPageSticky = !1),
                    t.classList.remove(Zl));
              } else
                (theme.variables.productPageSticky = !1),
                  t.classList.remove(Zl);
          }
          calculateStickyPosition(t = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked"))
              return void this.removeAnimationFrameSticky();
            const e = Boolean(t && t.detail),
              s = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              i = this.formWrapper.offsetHeight,
              o = window.innerHeight - i - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (
              (this.scrollDirectionDown
                ? (this.stickyScrollTop -= n)
                : (this.stickyScrollTop += n),
              this.stickyFormLoad)
            ) {
              if (document.querySelector(Gl)) {
                let { headerHeight: t } = a();
                this.stickyDefaultTop = t;
              } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
              this.stickyScrollTop = this.stickyDefaultTop;
            }
            this.stickyScrollTop = Math.min(
              Math.max(this.stickyScrollTop, o),
              this.stickyDefaultTop
            );
            const r = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * r),
              this.formWrapper.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (s && this.onChangeCounter <= 10) ||
              (s && this.stickyFormLastHeight !== i) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (s && (this.onChangeCounter += 1),
                  s &&
                    this.stickyFormLastHeight !== i &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky &&
                  this.removeAnimationFrameSticky(),
              (this.stickyFormLastHeight = i);
          }
          removeAnimationFrameSticky() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(tc)),
              (this.formWrapper = this.container.querySelector(Ql)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
              setTimeout(() => {
                this.init();
              }, 50);
          }
        })(this);
      },
      onUnload() {
        ec[this.id].onUnload();
      },
    },
    ic = "[data-button-arrow]",
    oc = "[data-deferred-media-button]",
    nc = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    rc = "[data-image-id]",
    ac = "[data-product-media-list]",
    lc = "[data-section-type]",
    cc = "slider__arrows",
    hc = "is-dragging",
    dc = "is-focused",
    uc = "media--active",
    pc = "media--hidden",
    mc = "media--hiding",
    vc = "data-active-media",
    gc = "data-button-prev",
    yc = "data-button-next",
    fc = "data-image-id",
    bc = "data-media-id",
    wc = "data-fader-desktop",
    Sc = "data-fader-mobile";
  let Ec = class extends HTMLElement {
    connectedCallback() {
      1 !== Object.keys(this.productMediaItems).length &&
        (this.productMediaObserver(),
        this.toggleEvents(),
        this.listen(),
        this.setHeight());
    }
    disconnectedCallback() {
      this.unlisten();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.toggleEvents),
        document.addEventListener("theme:resize:width", this.setHeight),
        this.addEventListener("theme:media:select", this.selectMediaEvent);
    }
    unlisten() {
      document.removeEventListener("theme:resize:width", this.toggleEvents),
        document.removeEventListener("theme:resize:width", this.setHeight),
        this.removeEventListener("theme:media:select", this.selectMediaEvent);
    }
    toggleEvents() {
      const t = y();
      (t && this.hasAttribute(Sc)) || (!t && this.hasAttribute(wc))
        ? this.bindEventListeners()
        : this.unbindEventListeners();
    }
    bindEventListeners() {
      this.initialized ||
        (this.productMediaList.addEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
        this.productMediaList.addEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.addEventListener(
          "touchstart",
          this.handleMouseDown,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
          passive: !0,
        }),
        this.productMediaList.addEventListener(
          "touchmove",
          this.handleMouseMove,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("keyup", this.handleKeyUp),
        this.initArrows(),
        this.resetScrollPosition(),
        (this.initialized = !0));
    }
    unbindEventListeners() {
      this.initialized &&
        (this.productMediaList.removeEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.removeEventListener(
          "mouseup",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener(
          "touchstart",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "touchend",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "touchmove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
        this.removeArrows(),
        (this.initialized = !1));
    }
    handleMouseDown(t) {
      (this.isDown = !0),
        (this.startX =
          (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft),
        (this.startY =
          (t.pageY || t.changedTouches[0].screenY) - this.offsetTop);
    }
    handleMouseLeave() {
      this.isDown && (this.isDown = !1);
    }
    handleMouseUp(t) {
      const e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
        s = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
        i = e - this.startX,
        o = s - this.startY,
        n = i > 0 ? 1 : -1;
      Math.abs(i) > 10 &&
        Math.abs(i) > Math.abs(o) &&
        (n < 0 ? this.showNextImage() : this.showPreviousImage()),
        (this.isDown = !1),
        requestAnimationFrame(() => {
          this.classList.remove(hc);
        });
    }
    handleMouseMove() {
      this.isDown && this.classList.add(hc);
    }
    handleKeyUp(t) {
      "ArrowLeft" === t.code && this.showPreviousImage(),
        "ArrowRight" === t.code && this.showNextImage();
    }
    handleArrowsClickEvent() {
      var t;
      null === (t = this.querySelectorAll(ic)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              t.target.hasAttribute(gc) && this.showPreviousImage(),
              t.target.hasAttribute(yc) && this.showNextImage();
          });
        });
    }
    resetScrollPosition() {
      0 !== this.productMediaList.scrollLeft &&
        (this.productMediaList.scrollLeft = 0);
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(cc),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.productMediaList.append(t),
          (this.buttons = this.querySelectorAll(ic)),
          (this.buttonPrev = this.querySelector(`[${gc}]`)),
          (this.buttonNext = this.querySelector(`[${yc}]`));
      }
      this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${cc}`)) || void 0 === t || t.remove();
    }
    preloadImageOnArrowHover() {
      var t, e;
      null === (t = this.buttonPrev) ||
        void 0 === t ||
        t.addEventListener("mouseover", () => {
          const t = this.getPreviousMediaId();
          this.preloadImage(t);
        }),
        null === (e = this.buttonNext) ||
          void 0 === e ||
          e.addEventListener("mouseover", () => {
            const t = this.getNextMediaId();
            this.preloadImage(t);
          });
    }
    preloadImage(t) {
      var e;
      null === (e = this.querySelector(`[${bc}="${t}"] img`)) ||
        void 0 === e ||
        e.setAttribute("loading", "eager");
    }
    showMediaOnVariantSelect(t) {
      const e = t.detail.id;
      this.setActiveMedia(e);
    }
    getCurrentMedia() {
      return this.querySelector(`${rc}.${uc}`);
    }
    getNextMediaId() {
      const t = this.getCurrentMedia(),
        e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(fc))
          ? null == t
            ? void 0
            : t.nextElementSibling
          : this.querySelector(rc);
      return null == e ? void 0 : e.getAttribute(bc);
    }
    getPreviousMediaId() {
      const t = this.getCurrentMedia(),
        e = this.productMediaItems.length - 1,
        s =
          (null == t ? void 0 : t.previousElementSibling) ||
          this.productMediaItems[e];
      return null == s ? void 0 : s.getAttribute(bc);
    }
    showNextImage() {
      const t = this.getNextMediaId();
      this.selectMedia(t);
    }
    showPreviousImage() {
      const t = this.getPreviousMediaId();
      this.selectMedia(t);
    }
    selectMedia(t) {
      this.dispatchEvent(
        new CustomEvent("theme:media:select", { detail: { id: t } })
      );
    }
    setActiveMedia(t) {
      if (!t) return;
      this.setAttribute(vc, t);
      const e = this.querySelector(`${rc}.${uc}`),
        s = this.querySelector(`[${bc}="${t}"]`),
        i = null == s ? void 0 : s.querySelector(nc),
        o = s.querySelector("deferred-media");
      var n;
      (null == e || e.classList.add(mc),
      null == e || e.classList.remove(uc),
      null == s || s.classList.remove(mc, pc),
      null == s || s.classList.add(uc),
      o && !0 !== o.getAttribute("loaded")) &&
        (null === (n = s.querySelector(oc)) ||
          void 0 === n ||
          n.dispatchEvent(new Event("click", { bubbles: !1 })));
      requestAnimationFrame(() => {
        this.setHeight(),
          document.body.classList.contains(dc) && (null == i || i.focus());
      });
    }
    setHeight() {
      var t, e;
      const s =
        (null === (t = this.querySelector(`${rc}.${uc}`)) || void 0 === t
          ? void 0
          : t.offsetHeight) ||
        (null === (e = this.productMediaItems[0]) || void 0 === e
          ? void 0
          : e.offsetHeight);
      this.style.setProperty("--height", `${s}px`);
    }
    productMediaObserver() {
      this.productMediaItems.forEach((t) => {
        t.addEventListener("transitionend", (e) => {
          e.target == t &&
            t.classList.contains(mc) &&
            (t.classList.remove(mc), t.classList.add(pc));
        }),
          t.addEventListener("transitioncancel", (e) => {
            e.target == t &&
              t.classList.contains(mc) &&
              (t.classList.remove(mc), t.classList.add(pc));
          });
      });
    }
    constructor() {
      super(),
        (this.initialized = !1),
        (this.buttons = !1),
        (this.isDown = !1),
        (this.startX = 0),
        (this.startY = 0),
        (this.scrollLeft = 0),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.container = this.closest(lc)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleKeyUp = this.handleKeyUp.bind(this)),
        (this.productMediaItems = this.querySelectorAll(rc)),
        (this.productMediaList = this.querySelector(ac)),
        (this.setHeight = this.setHeight.bind(this)),
        (this.toggleEvents = this.toggleEvents.bind(this)),
        (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
    }
  };
  const Lc = "data-option-position",
    kc = '[name^="options"], [data-popout-option]',
    Ac = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    Cc = "data-value",
    Tc = "[data-popout]",
    qc = "sold-out",
    xc = "unavailable",
    Pc = "sale";
  const Mc = "[data-product]",
    Ic = "[data-product-form]",
    Hc = "product-notification",
    Oc = "[data-variant-title]",
    Dc = "[data-notification-product]",
    Bc = "[data-add-to-cart]",
    _c = "[data-add-to-cart-text]",
    Fc = "cart-drawer",
    $c = "[data-cart-page]",
    Nc = "[data-compare-price]",
    Wc = "[data-compare-text]",
    Rc = "[data-form-wrapper]",
    zc = "[data-product-select]",
    Uc = "[data-price-wrapper]",
    Vc = "product-images",
    jc = "[data-product-media-list]",
    Xc = "[data-product-json]",
    Jc = "[data-product-price]",
    Yc = "[data-product-unit-price]",
    Qc = "[data-product-base]",
    Gc = "[data-product-unit]",
    Kc = "[data-product-preorder]",
    Zc = "[data-subscription-watch-price]",
    th = "[data-subscription-selectors]",
    eh = "[data-toggles-group]",
    sh = "data-group-toggle",
    ih = "[data-plan-description]",
    oh = "[data-section-type]",
    nh = "[data-variant-sku]",
    rh = "[data-variant-final-sale-metafield]",
    ah = "[data-variant-buttons]",
    lh = "[data-variant-option-image]",
    ch = "[data-quick-add-modal]",
    hh = "[data-price-off]",
    dh = "[data-price-off-type]",
    uh = "[data-price-off-amount]",
    ph = "[data-remaining-count]",
    mh = "[data-remaining-max]",
    vh = "[data-remaining-wrapper]",
    gh = "[data-product-remaining-json]",
    yh = "[data-option-value]",
    fh = "[data-option-position]",
    bh = "[data-product-form-installment]",
    wh = 'input[name="id"]',
    Sh = "hidden",
    Eh = "variant--soldout",
    Lh = "variant--unavailable",
    kh = "product__price--sale",
    Ah = "count-is-low",
    Ch = "count-is-in",
    Th = "count-is-out",
    qh = "count-is-unavailable",
    xh = "data-remaining-max",
    Ph = "data-enable-history-state",
    Mh = "data-fader-desktop",
    Ih = "data-fader-mobile",
    Hh = "data-option-position",
    Oh = "data-image-id",
    Dh = "data-media-id",
    Bh = "data-quick-add-btn",
    _h = "data-final-sale",
    Fh = "data-variant-image-scroll";
  let $h = class extends HTMLElement {
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container = this.closest(oh) || this.closest(ch)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.product = this.container.querySelector(Mc)),
        (this.productForm = this.container.querySelector(Ic)),
        (this.productNotification = this.container.querySelector(Hc)),
        (this.productImages = this.container.querySelector(Vc)),
        (this.productMediaList = this.container.querySelector(jc)),
        (this.installmentForm = this.container.querySelector(bh)),
        (this.skuWrapper = this.container.querySelector(nh)),
        (this.sellout = null),
        (this.variantImageScroll = "true" === this.container.getAttribute(Fh)),
        (this.priceOffWrap = this.container.querySelector(hh)),
        (this.priceOffAmount = this.container.querySelector(uh)),
        (this.priceOffType = this.container.querySelector(dh)),
        (this.planDescription = this.container.querySelector(ih)),
        (this.remainingWrapper = this.container.querySelector(vh)),
        this.remainingWrapper)
      ) {
        const t = this.container.querySelector(mh);
        t &&
          ((this.remainingMaxInt = parseInt(t.getAttribute(xh), 10)),
          (this.remainingCount = this.container.querySelector(ph)),
          (this.remainingJSONWrapper = this.container.querySelector(gh)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState = "true" === this.container.getAttribute(Ph)),
        (this.hasUnitPricing = this.container.querySelector(Gc)),
        (this.subSelectors = this.container.querySelector(th)),
        (this.subPrices = this.container.querySelector(Zc)),
        (this.isPreOrder = this.container.querySelector(Kc));
      let t = null;
      const e = this.container.querySelector(Xc);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new (class {
              init() {
                this.update();
              }
              update() {
                this.getCurrentState(),
                  this.optionElements.forEach((t) => {
                    const e = t.closest(`[${Lc}]`);
                    if (!e) return;
                    const s = t.value || t.getAttribute(Cc),
                      i = e.getAttribute(Lc),
                      o = parseInt(i, 10) - 1,
                      n = t.closest(Tc);
                    let r = [...this.selections];
                    r[o] = s;
                    const a = this.productJSON.variants.find((t) => {
                      let e = !0;
                      for (let s = 0; s < r.length; s++)
                        t.options[s] !== r[s] && (e = !1);
                      return e;
                    });
                    t.classList.remove(qc, xc),
                      t.parentNode.classList.remove(Pc),
                      n && n.classList.remove(qc, xc, Pc),
                      void 0 === a
                        ? (t.classList.add(xc), n && n.classList.add(xc))
                        : a &&
                          !1 === a.available &&
                          (t.classList.add(qc), n && n.classList.add(qc)),
                      a &&
                        a.compare_at_price > a.price &&
                        theme.settings.variantOnSale &&
                        t.parentNode.classList.add(Pc);
                  });
              }
              getCurrentState() {
                this.selections = [];
                const t = this.container.querySelectorAll(Ac);
                t.length &&
                  t.forEach((t) => {
                    const e = t.value;
                    e && "" !== e && this.selections.push(e);
                  });
              }
              constructor(t, e) {
                (this.container = t),
                  (this.productJSON = e),
                  (this.optionElements = this.container.querySelectorAll(kc)),
                  this.productJSON && this.optionElements.length && this.init();
              }
            })(this.container, this.productJSON)))
          : console.error("Missing product JSON"),
        (this.variantOptionImages = this.container.querySelectorAll(lh)),
        (this.variantButtons = this.container.querySelectorAll(ah)),
        this.variantOptionImages.length > 1 && this.optionImagesWidth();
    }
    cartAddEvents() {
      this.buttonATC = this.querySelector(Bc);
      const t = document.querySelector(Fc) || document.querySelector($c);
      this.buttonATC &&
        t &&
        this.buttonATC.addEventListener("click", (t) => {
          t.preventDefault(),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                detail: { button: this.buttonATC },
                bubbles: !1,
              })
            ),
            this.closest(ch) ||
              (window.accessibility.lastElement = this.buttonATC);
        });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new (class {
        destroy() {
          this._listeners.removeAll();
        }
        options() {
          return this._serializeInputValues(this.optionInputs, function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          });
        }
        variant() {
          const t = this.options();
          return t.length ? ta(this.product, t) : this.product.variants[0];
        }
        plan(t) {
          let e = { allocation: null, group: null, detail: null };
          const s = this.element.querySelector(`${ia}:checked`);
          if (!s) return null;
          const i = s.value,
            o = i && "" !== i ? i : null;
          return (
            o &&
              t &&
              (e.allocation = t.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id.toString() === o.toString();
              })),
            e.allocation &&
              (e.group = this.product.selling_plan_groups.find(function (t) {
                return (
                  t.id.toString() ===
                  e.allocation.selling_plan_group_id.toString()
                );
              })),
            e.group &&
              (e.detail = e.group.selling_plans.find(function (t) {
                return t.id.toString() === o.toString();
              })),
            e && e.allocation && e.detail && e.allocation ? e : null
          );
        }
        properties() {
          return this._serializeInputValues(this.propertyInputs, function (t) {
            return (
              (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
            );
          });
        }
        quantity() {
          return this.quantityInputs[0]
            ? Number.parseInt(this.quantityInputs[0].value, 10)
            : 1;
        }
        getFormState() {
          const t = this.variant();
          return {
            options: this.options(),
            variant: t,
            properties: this.properties(),
            quantity: this.quantity(),
            plan: this.plan(t),
          };
        }
        _setIdInputValue(t) {
          t && t.id
            ? (this.variantElement.value = t.id.toString())
            : (this.variantElement.value = ""),
            this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(t, e) {
          (e.dataset = this.getFormState()),
            t.onFormSubmit && t.onFormSubmit(e);
        }
        _onOptionChange(t) {
          this._setIdInputValue(t.dataset.variant);
        }
        _onFormEvent(t) {
          return void 0 === t
            ? Function.prototype.bind()
            : function (e) {
                (e.dataset = this.getFormState()),
                  this._setIdInputValue(e.dataset.variant),
                  t(e);
              }.bind(this);
        }
        _initInputs(t, e) {
          return Array.prototype.slice
            .call(this.element.querySelectorAll(t))
            .map(
              function (t) {
                return (
                  this._listeners.add(t, "change", this._onFormEvent(e)), t
                );
              }.bind(this)
            );
        }
        _serializeInputValues(t, e) {
          return t.reduce(function (t, s) {
            return (
              (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
                t.push(e({ name: s.name, value: s.value })),
              t
            );
          }, []);
        }
        _validateProductObject(t) {
          if ("object" != typeof t)
            throw new TypeError(t + " is not an object.");
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
            );
          return t;
        }
        constructor(t, e, s) {
          (this.element = t),
            (this.product = this._validateProductObject(e)),
            (this.variantElement = this.element.querySelector(sa)),
            (s = s || {}),
            (this._listeners = new Zr()),
            this._listeners.add(
              this.element,
              "submit",
              this._onSubmit.bind(this, s)
            ),
            (this.optionInputs = this._initInputs(oa, s.onOptionChange)),
            (this.planInputs = this._initInputs(ia, s.onPlanChange)),
            (this.quantityInputs = this._initInputs(na, s.onQuantityChange)),
            (this.propertyInputs = this._initInputs(ra, s.onPropertyChange));
        }
      })(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      var s;
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateNotificationForm(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSku(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        null === (s = this.sellout) || void 0 === s || s.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      const e = t.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(Uc),
        o = this.container.querySelectorAll(Bc),
        n = this.container.querySelectorAll(_c),
        r = this.container.querySelectorAll(Rc);
      if (this.installmentForm && e) {
        const t = this.installmentForm.querySelector(wh);
        (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          e &&
          i.forEach((t) => {
            t.classList.remove(Sh);
          }),
        null == o ||
          o.forEach((t) => {
            t.hasAttribute(Bh) ||
              (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
          }),
        null == n ||
          n.forEach((t) => {
            let i = s;
            e
              ? e.available || (i = theme.strings.soldOut)
              : (i = theme.strings.unavailable),
              (t.textContent = i);
          }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(Eh, Lh)
                : (t.classList.add(Eh), t.classList.remove(Lh));
              const s = t.querySelector(zc);
              s && (s.value = e.id);
              const i = t.querySelector(`${wh}[form]`);
              i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
            } else t.classList.add(Lh), t.classList.remove(Eh);
          });
    }
    updateNotificationForm(t) {
      if (!this.productNotification) return;
      const e = this.productNotification.querySelector(Oc),
        s = this.productNotification.querySelector(Dc);
      null != e &&
        ((e.textContent = t.variant.title), (s.value = t.variant.name));
    }
    updateHistoryState(t) {
      const e = t.variant,
        s = t.plan,
        i = window.location.href;
      if (e && i.includes("/product")) {
        const t = new window.URL(i),
          o = t.searchParams;
        o.set("variant", e.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const n = t.toString();
        window.history.replaceState({ path: n }, "", n);
      }
    }
    updateRemaining(t) {
      var e;
      const s = t.variant;
      if (
        (null === (e = this.remainingWrapper) ||
          void 0 === e ||
          e.classList.remove(Ch, Th, qh, Ah),
        s && this.remainingWrapper && this.remainingJSON)
      ) {
        const t = this.remainingJSON[s.id];
        ("out" === t || t < 1) && this.remainingWrapper.classList.add(Th),
          ("in" === t || t >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(Ch),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(Ah),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !s && this.remainingWrapper && this.remainingWrapper.classList.add(qh);
    }
    optionImagesWidth() {
      var t;
      if (!this.variantButtons) return;
      let e = 0;
      for (const t of this.variantOptionImages) {
        const s = t.offsetWidth;
        s > e && (e = s);
      }
      null === (t = this.variantButtons.style) ||
        void 0 === t ||
        t.setProperty("--option-image-width", e + "px");
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(eh).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              s = this.container.querySelector(`[${sh}="${e}"]`),
              i = this.container.querySelectorAll(`[${sh}]`);
            if (s) {
              s.classList.remove(Sh);
              const t = s.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            i.forEach((t) => {
              if (t !== s) {
                t.classList.add(Sh);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(Sh);
    }
    isVariantFinalSale(t) {
      const e = document.querySelector(rh).textContent,
        s = JSON.parse(e);
      let i = !1;
      return (
        s.forEach((e) => {
          Number(e.variant_id) === t.id && (i = "true" === e.metafield_value);
        }),
        i
      );
    }
    updateSaleTextStandard(t) {
      const e = t.variant;
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const t = (e.compare_at_price - e.price) / e.compare_at_price,
          s = Math.floor(100 * t);
        (this.priceOffAmount.innerHTML = `${s}%`),
          this.priceOffWrap.classList.remove(Sh);
      }
      this.priceOffWrap.hasAttribute(_h) || this.isVariantFinalSale(e)
        ? this.priceOffWrap.classList.remove(Sh)
        : this.priceOffWrap.classList.add(Sh);
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(Sh))
        : this.planDescription && this.planDescription.classList.add(Sh);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.plan.detail.price_adjustments[0],
          s = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${s}%`)
          : (this.priceOffAmount.innerHTML = He(s, theme.moneyFormat)),
          this.priceOffWrap.classList.remove(Sh);
      }
    }
    updateProductPrices(t) {
      const e = t.variant,
        s = t.plan;
      this.container.querySelectorAll(Uc).forEach((t) => {
        const i = t.querySelector(Nc),
          o = t.querySelector(Jc),
          n = t.querySelector(Wc);
        let r = "",
          a = "";
        this.productState.available &&
          ((r = e.compare_at_price), (a = e.price)),
          this.productState.hasPlan && (a = s.allocation.price),
          this.productState.planSale &&
            ((r = s.allocation.compare_at_price), (a = s.allocation.price)),
          i &&
            (this.productState.onSale || this.productState.planSale
              ? (i.classList.remove(Sh),
                n.classList.remove(Sh),
                o.classList.add(kh))
              : (i.classList.add(Sh),
                n.classList.add(Sh),
                o.classList.remove(kh)),
            (i.innerHTML = He(r, theme.moneyFormat))),
          (o.innerHTML =
            0 === a ? window.theme.strings.free : He(a, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        s = t.plan;
      let i = null;
      if (
        (e && e.unit_price && (i = e.unit_price),
        s &&
          s.allocation &&
          s.allocation.unit_price &&
          (i = s.allocation.unit_price),
        i)
      ) {
        const t = this.getBaseUnit(e),
          s = He(i, theme.moneyFormat);
        (this.container.querySelector(Yc).innerHTML = s),
          (this.container.querySelector(Qc).innerHTML = t),
          xe(this.container.querySelector(Gc));
      } else
        (o = this.container.querySelector(Gc)) && (o.style.display = "none");
      var o;
    }
    updateSku(t) {
      this.skuWrapper &&
        (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        s = t.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !s)
          ? (i.available = !1)
          : (e.available || (i.soldOut = !0),
            e.compare_at_price > e.price && (i.onSale = !0),
            e.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              e.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
          `[${Oh}="${e.featured_media.id}"]`
        );
        if (t) {
          const e = t.getAttribute(Dh),
            s = g();
          if (
            (t.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: e },
              })
            ),
            s &&
              !this.productImages.hasAttribute(Mh) &&
              this.variantImageScroll)
          ) {
            const e = t.getBoundingClientRect().top;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              sn(e);
          }
          s ||
            this.productImages.hasAttribute(Ih) ||
            this.productMediaList.scrollTo({ left: t.offsetLeft });
        }
      }
    }
    updateLegend(t) {
      const e = t.variant;
      if (e) {
        const t = this.container.querySelectorAll(yh);
        t.length &&
          t.forEach((t) => {
            const s = t.closest(fh);
            if (s) {
              const i = s.getAttribute(Hh),
                o = parseInt(i, 10) - 1,
                n = e.options[o];
              t.innerHTML = n;
            }
          });
      }
    }
    constructor() {
      super();
    }
  };
  const Nh = "[data-popup-open]",
    Wh = "[data-popup-close]",
    Rh = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    zh = "closing";
  let Uh = class {
    popupOpen() {
      this.popup &&
        ((this.isAnimating = !0),
        this.showModal && "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.showModal || "function" != typeof this.popup.show
          ? this.popup.setAttribute("open", "")
          : this.popup.show(),
        this.popup.removeAttribute("inert"),
        this.popup.focus(),
        this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
        ti(this.popup).then(() => {
          (this.isAnimating = !1),
            this.enableScrollLock && this.a11y.trapFocus(this.popup);
          const t =
            this.popup.querySelector("[autofocus]") ||
            this.popup.querySelector(Rh);
          null == t || t.focus();
        }));
    }
    popupClose() {
      if (
        !this.isAnimating &&
        this.popup &&
        !this.popup.hasAttribute("inert")
      ) {
        if (!this.popup.hasAttribute(zh))
          return (
            this.popup.setAttribute(zh, ""),
            (this.isAnimating = !0),
            void ti(this.popup).then(() => {
              (this.isAnimating = !1), this.popupClose();
            })
          );
        "function" == typeof this.popup.close
          ? this.popup.close()
          : this.popup.removeAttribute("open"),
          this.popupCloseActions();
      }
    }
    popupCloseActions() {
      this.popup.hasAttribute("inert") ||
        (this.popup.setAttribute("inert", ""),
        this.popup.removeAttribute(zh),
        !fl() &&
          this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          ),
        this.popup.dispatchEvent(
          new CustomEvent("theme:popup:onclose", { bubbles: !1 })
        ),
        this.enableScrollLock &&
          (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
    }
    popupEvents() {
      var t;
      if (!this.popup) return;
      null === (t = this.buttonPopupOpen) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(),
            this.popupOpen(),
            (window.accessibility.lastElement = this.buttonPopupOpen);
        });
      const e = this.popup.querySelectorAll(Wh);
      e.length &&
        e.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupClose();
          });
        }),
        this.showModal &&
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
        this.popup.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.popupClose());
        }),
        this.popup.addEventListener("close", () => this.popupCloseActions());
    }
    constructor(t, e, s = !0, i = !0) {
      var o;
      (this.popup = t),
        (this.holder = e),
        (this.a11y = N),
        (this.isAnimating = !1),
        (this.showModal = s),
        (this.enableScrollLock = i),
        (this.buttonPopupOpen =
          null === (o = this.holder) || void 0 === o
            ? void 0
            : o.querySelector(Nh)),
        this.popupEvents();
    }
  };
  const Vh = "dialog";
  let jh = class extends HTMLElement {
      connectedCallback() {
        new Uh(this.querySelector(Vh), this, !0, !0);
      }
      constructor() {
        super();
      }
    },
    Xh = class extends jt {
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(t) {
        t ||
          (this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer")
          ));
      }
      constructor() {
        super();
      }
    };
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const Jh = "[data-add-to-cart]",
    Yh = "[data-product-json]",
    Qh = "[data-product-form]",
    Gh = "#cart-bar",
    Kh = "[data-popup-open]",
    Zh = ".product__submit__add",
    td = "[data-form-wrapper]",
    ed = "[data-product-variants]",
    sd = "[data-slider]",
    id = "is-visible",
    od = "is-loading",
    nd = "data-cart-bar-enabled",
    rd = "data-add-to-cart-bar",
    ad = "data-cart-bar-scroll",
    ld = "data-cart-bar-product-notification",
    cd = "data-section-id",
    hd = "data-slider-index",
    dd = {};
  const ud = {
    onLoad() {
      dd[this.id] = new (class {
        initCartBar() {
          (this.cartBarBtns = this.cartBar.querySelectorAll(Zh)),
            this.cartBarBtns.length > 0 &&
              this.cartBarBtns.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(),
                    t.currentTarget.hasAttribute(rd)
                      ? (this.cartBarEnabled &&
                          (t.currentTarget.classList.add(od),
                          t.currentTarget.setAttribute("disabled", "disabled")),
                        this.form
                          .querySelector(Jh)
                          .dispatchEvent(new Event("click", { bubbles: !0 })))
                      : t.currentTarget.hasAttribute(ad)
                      ? this.scrollToTop()
                      : t.currentTarget.hasAttribute(ld) &&
                        this.container
                          .querySelector(Kh)
                          .dispatchEvent(new Event("click"));
                }),
                  t.hasAttribute(rd) &&
                    document.addEventListener(
                      "theme:product:add-error",
                      this.scrollToTop
                    );
              }),
            this.setCartBarHeight();
        }
        scrollToTop() {
          const t = this.container.querySelector(ed),
            e = (g() ? this.container : t || this.form).getBoundingClientRect()
              .top;
          sn(g() ? e : e - 10);
        }
        toggleCartBarOnScroll() {
          const t = window.scrollY,
            e =
              theme.variables.productPageSticky && this.formWrapper
                ? this.formWrapper
                : this.form;
          if (e && this.cartBar) {
            const s = t > e.offsetTop + e.offsetHeight;
            this.cartBar.classList.toggle(id, s);
          }
        }
        setCartBarHeight() {
          const t = this.cartBar.offsetHeight;
          document.documentElement.style.setProperty(
            "--cart-bar-height",
            `${t}px`
          );
        }
        onUnload() {
          document.removeEventListener(
            "theme:product:add-error",
            this.scrollToTop
          ),
            this.cartBarEnabled &&
              (document.removeEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.removeEventListener(
                "theme:resize",
                this.setCartBarHeight
              ));
        }
        onBlockSelect(t) {
          const e = t.srcElement.closest(sd);
          if (e && this.slider.length) {
            const s = e.hasAttribute(hd) ? e.getAttribute(hd) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockSelect(t);
          }
        }
        onBlockDeselect(t) {
          const e = t.srcElement.closest(sd);
          if (e && this.slider.length) {
            const s = e.hasAttribute(hd) ? e.getAttribute(hd) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockDeselect(t);
          }
        }
        constructor(t) {
          (this.section = t),
            (this.container = t.container),
            (this.id = this.container.getAttribute(cd)),
            (this.sliders = this.container.querySelectorAll(sd)),
            (this.slider = []),
            (this.formWrapper = this.container.querySelector(td)),
            (this.cartBarEnabled = this.container.hasAttribute(nd)),
            (this.cartBar = this.container.querySelector(Gh)),
            (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.toggleCartBarOnScroll =
              this.toggleCartBarOnScroll.bind(this)),
            (this.unlockTimer = 0),
            (this.accessibility = N);
          const e = this.container.querySelector(Yh);
          if ((e && !e.innerHTML) || !e) return;
          const s = JSON.parse(e.innerHTML).handle;
          let i = {};
          s && (i = { handle: s }),
            Shopify.Products.recordRecentlyViewed(i),
            (this.form = this.container.querySelector(Qh)),
            this.sliders.length &&
              this.sliders.forEach((t, e) => {
                t.setAttribute(hd, e),
                  this.slider.push(new tn(this.container, t));
              }),
            this.cartBarEnabled &&
              (this.initCartBar(),
              this.setCartBarHeight(),
              document.addEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.addEventListener("theme:resize", this.setCartBarHeight));
        }
      })(this);
    },
    onUnload(t) {
      dd[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      dd[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      dd[this.id].onBlockDeselect(t);
    },
  };
  vo("product", [ud, qo, yl, sc]),
    customElements.get("product-form") ||
      customElements.define("product-form", $h),
    customElements.get("product-images") ||
      customElements.define("product-images", Ec),
    customElements.get("product-modal") ||
      customElements.define("product-modal", jh),
    customElements.get("product-model") ||
      customElements.define("product-model", Xh),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", ja),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Oa),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", Jl);
  const pd = "[data-api-related-template]",
    md = "[data-related-section]",
    vd = "[data-grid-item]",
    gd = "[data-recent-wrapper]",
    yd = "[data-recently-viewed-wrapper]",
    fd = ".product-item",
    bd = "grid-slider",
    wd = "data-limit",
    Sd = "data-minimum",
    Ed = "data-product-id",
    Ld = "is-hidden",
    kd = "grid--mobile-slider",
    Ad = {};
  const Cd = {
    onLoad() {
      Ad[this.id] = new (class {
        related() {
          const t = this.container.querySelector(md);
          if (!t) return;
          const e = t.getAttribute(Ed),
            s = t.getAttribute(wd),
            i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
          fetch(i)
            .then((t) => t.text())
            .then((e) => {
              const s = document.createElement("div");
              (s.innerHTML = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(pd).innerHTML),
                s.querySelector(vd)
                  ? ((t.innerHTML = s.innerHTML),
                    0 ===
                      parseInt(t.style.getPropertyValue("--COLUMNS-MOBILE")) &&
                      t.querySelector(vd).parentElement.classList.add(kd))
                  : t.dispatchEvent(
                      new CustomEvent("theme:tab:hide", { bubbles: !0 })
                    );
            })
            .catch(function () {
              t.dispatchEvent(
                new CustomEvent("theme:tab:hide", { bubbles: !0 })
              );
            });
        }
        recent() {
          const t = this.container.querySelector(gd),
            e = t ? parseInt(t.getAttribute(wd)) : 4;
          Shopify.Products.showRecentlyViewed({
            howManyToShow: e,
            wrapperId: `recently-viewed-products-${this.sectionId}`,
            section: this.section,
            target: "api-product-grid-item",
            onComplete: (t, e) => {
              const s = e.container;
              if (!s) return;
              const i = s.querySelector(gd),
                o = s.querySelector(yd),
                n = t.querySelectorAll(fd),
                r = i.querySelector(bd),
                a = i.hasAttribute(Sd) ? parseInt(i.getAttribute(Sd)) : 4,
                l = !o && n.length > 0,
                c = o && n.length >= a;
              (l || c) &&
                (c && o.classList.remove(Ld),
                i.classList.remove("is-hidden"),
                i.dispatchEvent(
                  new CustomEvent("theme:tab:check", { bubbles: !0 })
                ),
                r &&
                  r.dispatchEvent(
                    new CustomEvent("theme:grid-slider:init", { bubbles: !0 })
                  ));
            },
          });
        }
        constructor(t) {
          (this.section = t),
            (this.sectionId = t.id),
            (this.container = t.container),
            this.related(),
            this.recent();
        }
      })(this);
    },
  };
  vo("related", [Cd, yl]), vo("reviews", [en, Rr]);
  const Td = {},
    qd = "[data-slider-logos]",
    xd = "[data-slider-text]",
    Pd = "[data-slide]",
    Md = "is-selected",
    Id = "is-initialized",
    Hd = "flickity-enabled",
    Od = "data-slide",
    Dd = "data-slide-index";
  vo("logos", [
    {
      onLoad() {
        Td[this.id] = new (class {
          getSlidesWidth() {
            return 200 * this.logoSlides.length;
          }
          initSlideshowText() {
            this.slideshowText &&
              (this.flkty = new i(this.slideshowText, {
                fade: !0,
                autoPlay: !1,
                prevNextButtons: !1,
                cellAlign: "left",
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: 0.2,
                friction: 0.6,
                draggable: !1,
                accessibility: !1,
                on: {
                  ready: () => this.sliderAccessibility(),
                  change: () => this.sliderAccessibility(),
                },
              }));
          }
          sliderAccessibility() {
            const t = this.slideshowText.querySelectorAll(
              `${Pd} a, ${Pd} button`
            );
            t.length &&
              t.forEach((t) => {
                const e = t.closest(Pd);
                if (e) {
                  const s = e.classList.contains(Md) ? 0 : -1;
                  t.setAttribute("tabindex", s);
                }
              });
          }
          initSlideshowNav() {
            this.slideshowNav &&
              (this.logoSlides.length &&
                this.logoSlides.forEach((t) => {
                  t.addEventListener("click", () => {
                    const e = parseInt(t.getAttribute(Dd)),
                      s = this.slideshowNav.classList.contains(Hd);
                    if ((this.flkty && this.flkty.select(e), s))
                      this.flktyNav.select(e),
                        this.slideshowNav.classList.contains(Md) ||
                          this.flktyNav.playPlayer();
                    else {
                      const e = this.slideshowNav.querySelector(`.${Md}`);
                      e && e.classList.remove(Md), t.classList.add(Md);
                    }
                  });
                }),
              this.setSlideshowNavState(),
              document.addEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          setSlideshowNavState() {
            const t = this.slideshowNav.classList.contains(Hd);
            if (this.logoSlidesWidth > m()) {
              if (!t) {
                this.slideshowNav.classList.add(Id);
                const t = this.slideshowNav.querySelector(`.${Md}`);
                t && t.classList.remove(Md),
                  this.logoSlides[0].classList.add(Md),
                  this.flktyNav ||
                    ((this.flktyNav = new s(this.slideshowNav, {
                      autoPlay: 4e3,
                      prevNextButtons: !1,
                      contain: !1,
                      pageDots: !1,
                      wrapAround: !0,
                      watchCSS: !0,
                      selectedAttraction: 0.05,
                      friction: 0.8,
                      initialIndex: 0,
                    })),
                    this.flktyNav.on("deactivate", () => {
                      this.slideshowNav.querySelector(Pd).classList.add(Md),
                        this.flkty && this.flkty.select(0);
                    }),
                    this.flkty &&
                      (this.flkty.select(0),
                      this.flktyNav.on("change", (t) => this.flkty.select(t))));
              }
            } else t && this.slideshowNav.classList.remove(Id);
          }
          onBlockSelect(t) {
            if (!this.slideshowNav) return;
            const e = this.slideshowNav.querySelector(
                `[${Od}="${t.detail.blockId}"]`
              ),
              s = parseInt(e.getAttribute(Dd));
            this.slideshowNav.classList.contains(Hd)
              ? (this.flktyNav.select(s),
                this.flktyNav.stopPlayer(),
                this.slideshowNav.classList.add(Md))
              : e.dispatchEvent(new Event("click"));
          }
          onBlockDeselect() {
            this.slideshowNav &&
              this.slideshowNav.classList.contains(Hd) &&
              (this.flktyNav.playPlayer(),
              this.slideshowNav.classList.remove(Md));
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize",
              this.setSlideshowNavStateOnResize
            );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slideshowNav = this.container.querySelector(qd)),
              (this.slideshowText = this.container.querySelector(xd)),
              (this.setSlideshowNavStateOnResize = () =>
                this.setSlideshowNavState()),
              (this.flkty = null),
              (this.flktyNav = null),
              (this.logoSlides = this.slideshowNav.querySelectorAll(Pd)),
              (this.logoSlidesWidth = this.getSlidesWidth()),
              this.initSlideshowText(),
              this.initSlideshowNav();
          }
        })(this);
      },
      onUnload(t) {
        Td[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Td[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        Td[this.id].onBlockDeselect(t);
      },
    },
    Rr,
  ]);
  const Bd = {};
  function _d(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return Bd[t.url]
        ? Bd[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (Bd[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return Bd[t.json]
        ? Promise.resolve(Bd[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((Bd[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return Bd[e]
        ? Bd[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (Bd[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const Fd = ".pswp",
    $d = ".pswp__custom-close",
    Nd = "iframe, video",
    Wd = ".pswp__thumbs",
    Rd = "is-current",
    zd = "pswp--custom-loader",
    Ud = "pswp--custom-opening",
    Vd = "pswp__loader",
    jd = "is-focused",
    Xd = "data-pswp-option-classes",
    Jd = "aria-current",
    Yd = `<div class="${Vd}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  const Qd = "data-video-play";
  let Gd = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.videoPlay = this.querySelectorAll(`[${Qd}]`)),
        null === (t = this.videoPlay) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("click", (t) => {
              const e = t.currentTarget;
              if ("" !== e.getAttribute(Qd).trim()) {
                t.preventDefault();
                const s = [{ html: e.getAttribute(Qd) }],
                  i = { mainClass: "pswp--video" };
                new (class {
                  init() {
                    this.pswpElement.classList.add(Ud),
                      this.initLoader(),
                      _d({ url: window.theme.assets.photoswipe })
                        .then(() => this.loadPopup())
                        .catch((t) => console.error(t));
                  }
                  initLoader() {
                    if (
                      this.pswpElement.classList.contains(zd) &&
                      "" !== this.options &&
                      this.options.mainClass
                    ) {
                      this.pswpElement.setAttribute(Xd, this.options.mainClass);
                      let t = document.createElement("div");
                      (t.innerHTML = Yd),
                        (t = t.firstChild),
                        this.pswpElement.appendChild(t);
                    } else this.pswpElement.setAttribute(Xd, "");
                  }
                  loadPopup() {
                    const t = window.themePhotoswipe.PhotoSwipe.default,
                      e = window.themePhotoswipe.PhotoSwipeUI.default;
                    this.pswpElement.classList.contains(zd) &&
                      this.pswpElement.classList.remove(zd),
                      this.pswpElement.classList.remove(Ud),
                      (this.popup = new t(
                        this.pswpElement,
                        e,
                        this.items,
                        this.options
                      )),
                      this.popup.init(),
                      this.thumbsActions(),
                      document.body.classList.contains(jd) &&
                        setTimeout(() => {
                          this.a11y.trapFocus(this.pswpElement, {
                            elementToFocus: this.closeBtn,
                          });
                        }, 200),
                      this.popup.listen("close", () => this.onClose()),
                      this.options &&
                        this.options.closeElClasses &&
                        this.options.closeElClasses.length &&
                        this.options.closeElClasses.forEach((t) => {
                          const e = this.pswpElement.querySelector(
                            `.pswp__${t}`
                          );
                          e &&
                            e.addEventListener("keyup", this.keyupCloseEvent);
                        });
                  }
                  thumbsActions() {
                    this.popupThumbsContainer &&
                      this.popupThumbsContainer.children.length &&
                      (this.popupThumbsContainer.addEventListener(
                        "wheel",
                        (t) => this.stopDisabledScroll(t)
                      ),
                      this.popupThumbsContainer.addEventListener(
                        "mousewheel",
                        (t) => this.stopDisabledScroll(t)
                      ),
                      this.popupThumbsContainer.addEventListener(
                        "DOMMouseScroll",
                        (t) => this.stopDisabledScroll(t)
                      ),
                      (this.popupThumbs = this.pswpElement.querySelectorAll(
                        `${Wd} > *`
                      )),
                      this.popupThumbs.forEach((t, e) => {
                        t.addEventListener("click", (s) => {
                          s.preventDefault();
                          const i = t.parentElement.querySelector(`.${Rd}`);
                          i.classList.remove(Rd),
                            i.setAttribute(Jd, !1),
                            t.classList.add(Rd),
                            t.setAttribute(Jd, !0),
                            this.popup.goTo(e);
                        });
                      }),
                      this.popup.listen("imageLoadComplete", () =>
                        this.setCurrentThumb()
                      ),
                      this.popup.listen("beforeChange", () =>
                        this.setCurrentThumb()
                      ));
                  }
                  stopDisabledScroll(t) {
                    t.stopPropagation();
                  }
                  keyupClose(t) {
                    "Enter" === t.code && this.popup.close();
                  }
                  onClose() {
                    const t = this.pswpElement.querySelector(Nd);
                    if (
                      (t && t.parentNode.removeChild(t),
                      this.popupThumbsContainer &&
                        this.popupThumbsContainer.firstChild)
                    )
                      for (; this.popupThumbsContainer.firstChild; )
                        this.popupThumbsContainer.removeChild(
                          this.popupThumbsContainer.firstChild
                        );
                    this.pswpElement.setAttribute(Xd, "");
                    const e = this.pswpElement.querySelector(`.${Vd}`);
                    e && this.pswpElement.removeChild(e),
                      this.options &&
                        this.options.closeElClasses &&
                        this.options.closeElClasses.length &&
                        this.options.closeElClasses.forEach((t) => {
                          const e = this.pswpElement.querySelector(
                            `.pswp__${t}`
                          );
                          e &&
                            e.removeEventListener(
                              "keyup",
                              this.keyupCloseEvent
                            );
                        }),
                      this.a11y.removeTrapFocus(),
                      this.a11y.autoFocusLastElement();
                  }
                  setCurrentThumb() {
                    const t = this.pswpElement.querySelector(`${Wd} > .${Rd}`);
                    if (
                      (t && (t.classList.remove(Rd), t.setAttribute(Jd, !1)),
                      !this.popupThumbs)
                    )
                      return;
                    const e = this.popupThumbs[this.popup.getCurrentIndex()];
                    e.classList.add(Rd),
                      e.setAttribute(Jd, !0),
                      this.scrollThumbs(e);
                  }
                  scrollThumbs(t) {
                    const e =
                        this.popupThumbsContainer.scrollLeft +
                        this.popupThumbsContainer.offsetWidth,
                      s = t.offsetLeft;
                    if (e <= s + t.offsetWidth || e > s) {
                      const e = parseInt(window.getComputedStyle(t).marginLeft);
                      this.popupThumbsContainer.scrollTo({
                        top: 0,
                        left: s - e,
                        behavior: "smooth",
                      });
                    }
                  }
                  constructor(t, e = "") {
                    (this.items = t),
                      (this.pswpElement = document.querySelectorAll(Fd)[0]),
                      (this.popup = null),
                      (this.popupThumbs = null),
                      (this.popupThumbsContainer =
                        this.pswpElement.querySelector(Wd)),
                      (this.closeBtn = this.pswpElement.querySelector($d)),
                      (this.keyupCloseEvent = (t) => this.keyupClose(t)),
                      (this.a11y = N),
                      (this.options =
                        "" !== e
                          ? e
                          : { history: !1, focus: !1, mainClass: "" }),
                      this.init();
                  }
                })(s, i),
                  (window.accessibility.lastElement = e);
              }
            });
          });
    }
    constructor() {
      super();
    }
  };
  const Kd = "[data-video-template]",
    Zd = "is-loading",
    tu = "data-video-id";
  let eu = class extends HTMLElement {
    connectedCallback() {
      (this.videoId = this.getAttribute(tu)),
        (this.videoTemplate = this.querySelector(Kd)),
        (this.video = null),
        (this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this)),
        this.videoId && this.renderVideo();
    }
    powerSaverVideoPlay() {
      var t;
      null === (t = this.video) || void 0 === t || t.play();
    }
    renderVideo() {
      (this.videoTemplateObserver = new IntersectionObserver(
        (t, e) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              const s = this.videoTemplate.innerHTML;
              (this.innerHTML = s),
                this.classList.remove(Zd),
                (this.video = this.querySelector("video")),
                this.observeVideoPlayToggle(),
                this.video
                  .play()
                  .then(() => {})
                  .catch(() => {
                    document.addEventListener(
                      "click",
                      this.powerSaverVideoPlay,
                      { passive: !0, bubbles: !0, once: !0 }
                    ),
                      document.addEventListener(
                        "touchstart",
                        this.powerSaverVideoPlay,
                        { passive: !0, bubbles: !0, once: !0 }
                      );
                  }),
                e.unobserve(t.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      )),
        this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      if (!this.video) return;
      (this.videoPlayObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            const e = t.isIntersecting;
            if (e && "function" == typeof this.video.play) {
              const t = this.video.play();
              void 0 !== t && t.then((t) => {}).catch((t) => {});
            }
            e || "function" != typeof this.video.pause || this.video.pause();
          });
        },
        { rootMargin: "0px", threshold: [0, 1] }
      )),
        this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
        this.videoPlayObserver && this.videoPlayObserver.disconnect(),
        this.videoId &&
          (document.removeEventListener("click", this.powerSaverVideoPlay),
          document.removeEventListener("touchstart", this.powerSaverVideoPlay));
    }
    constructor() {
      super();
    }
  };
  vo("featured-video", [Po]),
    customElements.get("video-background") ||
      customElements.define("video-background", eu),
    customElements.get("video-popup") ||
      customElements.define("video-popup", Gd),
    vo("slideshow", [en, Po]);
  const su = "[data-image-holder]",
    iu = "[data-image-element]",
    ou = "[data-range-button]",
    nu = "[data-range-input]";
  let ru = class extends HTMLElement {
    connectedCallback() {
      this.setOverlapImageSize(),
        this.setImagePosition(),
        this.rangeInput.addEventListener("input", () =>
          this.setImagePosition()
        ),
        document.addEventListener("theme:resize", this.setOverlapImageSize);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.setOverlapImageSize);
    }
    setImagePosition() {
      const t = this.rangeInput.value,
        e = this.imageElement.offsetWidth,
        s = this.rangeButton.offsetWidth;
      (this.rangeButton.style.left = `${t}%`),
        (this.imageHolder.style.width =
          ((e - s) * (100 - t)) / 100 + s / 2 + "px");
    }
    setOverlapImageSize() {
      const t = this.offsetWidth;
      (this.imageElement.style.width = `${t}px`), this.setImagePosition();
    }
    constructor() {
      super(),
        (this.imageHolder = this.querySelector(su)),
        (this.imageElement = this.querySelector(iu)),
        (this.rangeButton = this.querySelector(ou)),
        (this.rangeInput = this.querySelector(nu)),
        (this.setOverlapImageSize = this.setOverlapImageSize.bind(this));
    }
  };
  vo("custom-content", [en, Po, pn]),
    customElements.get("video-background") ||
      customElements.define("video-background", eu),
    customElements.get("video-popup") ||
      customElements.define("video-popup", Gd),
    customElements.get("compare-images") ||
      customElements.define("compare-images", ru);
  var au = {};
  function lu(t) {
    return au[t];
  }
  (au.basic = []),
    (au.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (au.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (au.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let cu = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  vo("map", {
    onLoad() {
      cu[this.id] = new (class {
        initMaps() {
          (function (t) {
            if (null === window.theme.mapAPI) {
              const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
              window.theme.mapAPI = _d({ url: e });
            }
            return window.theme.mapAPI;
          })(this.key)
            .then(() => {
              return "true" === this.enableCorrection &&
                "" !== this.lat &&
                "" !== this.long
                ? new google.maps.LatLng(this.lat, this.long)
                : ((t = this.address),
                  new Promise((e, s) => {
                    new google.maps.Geocoder().geocode(
                      { address: t },
                      function (t, i) {
                        if ("OK" == i) {
                          var o = {
                            lat: t[0].geometry.location.lat(),
                            lng: t[0].geometry.location.lng(),
                          };
                          e(o);
                        } else s(i);
                      }
                    );
                  }));
              var t;
            })
            .then((t) => {
              const e = {
                  zoom: parseInt(this.zoomString, 10),
                  styles: lu(this.styleString),
                  center: t,
                  draggable: !0,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  zoomControl: !1,
                  disableDefaultUI: !0,
                },
                s = (function (t, e) {
                  var s = new google.maps.Map(t, e),
                    i = s.getCenter();
                  return (
                    new google.maps.Marker({ map: s, position: i }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      function () {
                        google.maps.event.trigger(s, "resize"), s.setCenter(i);
                      }
                    ),
                    s
                  );
                })(this.mapContainer, e);
              return s;
            })
            .then((t) => {
              (this.map = t), (cu[this.id] = t);
            })
            .catch((t) => {
              console.log("Failed to load Google Map"), console.log(t);
            });
        }
        unload() {
          void 0 !== window.google &&
            google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(t) {
          (this.container = t.container),
            (this.mapContainer = this.container.querySelector(
              "[data-map-container]"
            )),
            (this.key = this.container.getAttribute("data-api-key")),
            (this.styleString =
              this.container.getAttribute("data-style") || ""),
            (this.zoomString = this.container.getAttribute("data-zoom") || 14),
            (this.address = this.container.getAttribute("data-address")),
            (this.enableCorrection = this.container.getAttribute(
              "data-latlong-correction"
            )),
            (this.lat = this.container.getAttribute("data-lat")),
            (this.long = this.container.getAttribute("data-long")),
            this.key && this.initMaps();
        }
      })(this);
    },
    onUnload() {
      "function" == typeof cu[this.id].unload && cu[this.id].unload();
    },
  });
  const hu = "[data-large-promo]",
    du = "[data-large-promo-inner]",
    uu = "[data-tracking-consent]",
    pu = "[data-confirm-cookies]",
    mu = "cart-bar",
    vu = "[data-newsletter]",
    gu = "[data-newsletter-holder]",
    yu = "[data-newsletter-heading]",
    fu = "[data-newsletter-field]",
    bu = "[data-promo-text]",
    wu = "[data-newsletter-form]",
    Su = "data-popup-delay",
    Eu = "data-cookie-name",
    Lu = "data-target-referrer",
    ku = "hidden",
    Au = "has-value",
    Cu = "cart-bar-visible",
    Tu = "is-visible",
    qu = "has-success",
    xu = "selected",
    Pu = "has-block-selected",
    Mu = "mobile",
    Iu = "desktop",
    Hu = "bottom",
    Ou = "data-enable";
  let Du = {},
    Bu = class {
      always() {
        this.popupActions.popupOpen();
      }
      delayed(t = 10) {
        setTimeout(() => {
          this.popupActions.popupOpen();
        }, 1e3 * t);
      }
      idle() {
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          s = ["load", "resize", "scroll"],
          i = () => {
            (t = setTimeout(() => {
              (t = 0), this.popupActions.popupOpen();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              s.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              s.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              i();
          };
        i();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.popupActions.popupOpen(),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e, s) {
        if (
          ((this.element = e),
          (this.delay = t.getAttribute(Su)),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.popupActions = s),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(t);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    _u = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(Lu)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(t) {
        if (
          ((this.el = t),
          (this.locationPath = location.href),
          !this.el.hasAttribute(Lu))
        )
          return !1;
        this.init();
      }
    };
  const Fu = {
    onLoad() {
      Du[this.id] = [];
      this.container.querySelectorAll(hu).forEach((t) => {
        Du[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e = this.popup.classList.contains(Mu),
                s = this.popup.classList.contains(Iu),
                i = !g();
              let o = !0;
              if ((((e && !i) || (s && i)) && (o = !1), !o))
                return (
                  this.a11y.removeTrapFocus(),
                  void document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  )
                );
              (t && !window.Shopify.designMode) ||
                (window.Shopify.designMode ||
                  window.location.pathname.endsWith("/challenge") ||
                  new Bu(this.popup, this.modal, this.popupActions),
                this.form &&
                  this.form.classList.contains(qu) &&
                  this.checkForSuccess(),
                this.modal.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(xu),
                this.popup.parentNode.classList.add(Pu));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(xu),
                this.popup.parentNode.classList.remove(Pu));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = this.popup.querySelector(du)),
                (this.form = this.popup.querySelector(wu)),
                (this.cookie = new on(
                  this.popup.getAttribute(Eu),
                  "user_has_closed"
                )),
                (this.isTargeted = new _u(this.popup)),
                (this.popupActions = new Uh(this.modal, this.modal, !0, !0)),
                (this.a11y = N),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(uu).forEach((t) => {
        Du[this.id].push(
          new (class {
            init() {
              this.showPopup && this.popupActions.popupOpen(),
                this.clickEvents();
            }
            clickEvents() {
              this.acceptButton.addEventListener("click", (t) => {
                t.preventDefault(),
                  window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
                    this.popupActions.popupClose()
                  ),
                  document.documentElement.style.setProperty(
                    "--cookie-bar-height",
                    "0px"
                  );
              }),
                document.addEventListener("trackingConsentAccepted", () => {});
            }
            onSelect() {
              this.showPopup &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(xu),
                this.popup.parentNode.classList.add(Pu));
            }
            onDeselect() {
              this.showPopup &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(xu),
                this.popup.parentNode.classList.remove(Pu));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = document.querySelector(uu)),
                (this.acceptButton = this.modal.querySelector(pu)),
                (this.enable = "true" === this.modal.getAttribute(Ou)),
                (this.showPopup = !1),
                (this.popupActions = new Uh(this.popup, this.popup, !1, !1)),
                window.Shopify.loadFeatures(
                  [{ name: "consent-tracking-api", version: "0.1" }],
                  (t) => {
                    if (t) throw t;
                    const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                      s = window.Shopify.customerPrivacy.getTrackingConsent();
                    (this.showPopup =
                      !e && "no_interaction" === s && this.enable),
                      window.Shopify.designMode && (this.showPopup = !0),
                      this.init();
                  }
                );
            }
          })(t)
        );
      });
      this.container.querySelectorAll(vu).forEach((t) => {
        Du[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e =
                  -1 !==
                  window.location.search.indexOf("?customer_posted=true"),
                s = [...this.holder.classList].toString().includes(Hu);
              e && (this.delay = 0),
                (t && !window.Shopify.designMode) ||
                  (this.show(),
                  this.form.classList.contains(qu) && this.checkForSuccess()),
                s && this.observeCartBar();
            }
            show() {
              window.location.pathname.endsWith("/challenge") ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new Bu(this.popup, this.holder, this.popupActions)),
                this.showForm(),
                this.inputField(),
                this.holder.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                );
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            observeCartBar() {
              if (((this.cartBar = document.getElementById(mu)), !this.cartBar))
                return;
              let t = this.cartBar.classList.contains(Tu);
              document.body.classList.toggle(Cu, t),
                (this.observer = new MutationObserver((e) => {
                  for (const s of e)
                    "attributes" === s.type &&
                      ((t = s.target.classList.contains(Tu)),
                      document.body.classList.toggle(Cu, t));
                })),
                this.observer.observe(this.cartBar, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                });
            }
            showForm() {
              this.heading.addEventListener("click", (t) => {
                t.preventDefault(),
                  this.heading.classList.add(ku),
                  this.form.classList.remove(ku),
                  this.newsletterField.focus();
              }),
                this.heading.addEventListener("keyup", (t) => {
                  "Enter" === t.code &&
                    this.heading.dispatchEvent(new Event("click"));
                });
            }
            inputField() {
              const t = () => {
                this.resetClassTimer && clearTimeout(this.resetClassTimer),
                  "" !== this.newsletterField.value &&
                    this.holder.classList.add(Au);
              };
              this.newsletterField.addEventListener("input", t),
                this.newsletterField.addEventListener("focus", t),
                this.newsletterField.addEventListener("focusout", () => {
                  this.resetClassTimer && clearTimeout(this.resetClassTimer),
                    (this.resetClassTimer = setTimeout(() => {
                      this.holder.classList.remove(Au);
                    }, 2e3));
                });
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(xu),
                this.popup.parentNode.classList.add(Pu));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(xu),
                this.popup.parentNode.classList.remove(Pu));
            }
            onUnload() {
              this.observer && this.observer.disconnect();
            }
            constructor(t) {
              (this.popup = t),
                (this.holder = this.popup.querySelector(gu)),
                (this.heading = this.popup.querySelector(yu)),
                (this.newsletterField = this.popup.querySelector(fu)),
                (this.cookie = new on(
                  this.popup.getAttribute(Eu),
                  "newsletter_is_closed"
                )),
                (this.form = this.popup.querySelector(wu)),
                (this.isTargeted = new _u(this.popup)),
                (this.popupActions = new Uh(this.holder, this.holder, !1, !1)),
                (this.resetClassTimer = 0),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(bu).forEach((t) => {
        Du[this.id].push(
          new (class {
            init() {
              (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new Bu(this.popup, this.popup, this.popupActions),
                this.popup.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            onSelect() {
              this.popupActions.popupOpen(),
                this.popup.classList.add(xu),
                this.popup.parentNode.classList.add(Pu);
            }
            onDeselect() {
              this.popupActions.popupClose(),
                this.popup.classList.remove(xu),
                this.popup.parentNode.classList.remove(Pu);
            }
            constructor(t) {
              (this.popup = t),
                (this.cookie = new on(
                  this.popup.getAttribute(Eu),
                  "user_has_closed"
                )),
                (this.isTargeted = new _u(this.popup)),
                (this.popupActions = new Uh(this.popup, this.popup, !1, !1)),
                this.init();
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      Du[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      Du[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
    onSelect() {
      Du[this.id].forEach((t) => {
        "function" == typeof t.onSelect && t.onSelect();
      });
    },
    onDeselect() {
      Du[this.id].forEach((t) => {
        "function" == typeof t.onDeselect && t.onDeselect();
      });
    },
    onUnload() {
      Du[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  vo("popups", [Fu, pn]);
  const $u = "[data-password-modal]",
    Nu = "#login_form .errors";
  vo("password-template", {
    onLoad() {
      new (class {
        constructor(t) {
          (this.container = t.container),
            (this.popupActions = new Uh(
              this.container.querySelector($u),
              this.container,
              !0,
              !0
            )),
            this.container.querySelector(Nu) && this.popupActions.popupOpen();
        }
      })(this);
    },
  }),
    vo("list-collections", [en, Rr]),
    vo("columns", [Rr, en]),
    vo("newsletter", pn),
    customElements.get("compare-images") ||
      customElements.define("compare-images", ru);
  const Wu = "[data-scroll-to]",
    Ru = "[data-tooltip]",
    zu = "[data-collapsible-trigger]",
    Uu = "open",
    Vu = "data-scroll-to",
    ju = "data-tooltip-stop-mouseenter",
    Xu = {};
  const Ju = {
      onLoad() {
        Xu[this.id] = new (class {
          init() {
            this.scrollToButtons.forEach((t) => {
              t.addEventListener("click", () => {
                const e = this.container.querySelector(t.getAttribute(Vu));
                e && "A" !== t.tagName && this.scrollToElement(e);
              });
            });
          }
          scrollToElement(t) {
            sn(t.getBoundingClientRect().top + 1);
            const e = t.nextElementSibling.matches("details")
              ? t.nextElementSibling
              : null;
            if (e) {
              const t = null == e ? void 0 : e.querySelector(zu);
              e.hasAttribute(Uu) ||
                null == t ||
                t.dispatchEvent(new Event("click"));
            }
            const s = document.querySelectorAll(`${Ru}:not([${ju}])`);
            s.length &&
              s.forEach((t) => {
                t.setAttribute(ju, ""),
                  setTimeout(() => {
                    t.removeAttribute(ju);
                  }, 1e3);
              });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollToButtons = this.container.querySelectorAll(Wu)),
              this.scrollToButtons.length && this.init();
          }
        })(this);
      },
    },
    Yu = "[data-scroll-spy]",
    Qu = "is-selected",
    Gu = "data-scroll-spy",
    Ku = "data-scroll-spy-mobile",
    Zu = "data-scroll-spy-desktop",
    tp = "data-scroll-trigger-point",
    ep = {};
  const sp = {
    onLoad() {
      var t;
      (ep[this.id] = []),
        null === (t = this.container.querySelectorAll(Yu)) ||
          void 0 === t ||
          t.forEach((t) => {
            const e = this.container.querySelector(t.getAttribute(Gu));
            ep[this.id].push(
              new (class {
                init() {
                  this.toggleScrollObserver(),
                    document.addEventListener(
                      "theme:resize:width",
                      this.toggleScrollObserver
                    );
                }
                toggleScrollObserver() {
                  this.isEligible()
                    ? this.initialized ||
                      (document.addEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !0))
                    : (document.removeEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !1));
                }
                isEligible() {
                  const t = g();
                  return (
                    (!t && this.anchor.hasAttribute(Ku)) ||
                    (t && this.anchor.hasAttribute(Zu)) ||
                    (!this.anchor.hasAttribute(Zu) &&
                      !this.anchor.hasAttribute(Ku))
                  );
                }
                onScroll() {
                  this.top = this.elementToSpy.getBoundingClientRect().top;
                  const t = Math.round(window.innerHeight),
                    e = Math.round(window.scrollY),
                    s = e + t,
                    i = Math.round(this.top + e),
                    o = this.elementToSpy.offsetHeight;
                  i < s &&
                    !(i + o < e) &&
                    this.triggerPointReached() &&
                    (this.anchorSiblings.forEach((t) => {
                      t.matches(this.anchorSelector) || t.classList.remove(Qu);
                    }),
                    this.anchor.classList.add(Qu));
                }
                triggerPointReached() {
                  let t = !1;
                  switch (this.triggerPoint) {
                    case "top":
                    default:
                      t = this.top <= 0;
                      break;
                    case "middle":
                      t = this.top <= window.innerHeight / 2;
                      break;
                    case "bottom":
                      t = this.top <= window.innerHeight;
                  }
                  return t;
                }
                onUnload() {
                  document.removeEventListener(
                    "theme:resize:width",
                    this.toggleScrollObserver
                  ),
                    document.removeEventListener(
                      "theme:scroll",
                      this.scrollCallback
                    );
                }
                constructor(t, e) {
                  (this.container = t),
                    (this.elementToSpy = e),
                    (this.anchorSelector = `[${Gu}="#${this.elementToSpy.id}"]`),
                    (this.anchor = this.container.querySelector(
                      this.anchorSelector
                    )),
                    (this.anchorSiblings = this.container.querySelectorAll(
                      `[${Gu}]`
                    )),
                    (this.initialized = !1),
                    this.anchor &&
                      ((this.triggerPoint = this.anchor.getAttribute(tp)),
                      (this.scrollCallback = () => this.onScroll()),
                      (this.toggleScrollObserver =
                        this.toggleScrollObserver.bind(this)),
                      this.init());
                }
              })(this.container, e)
            );
          });
    },
    onUnload() {
      ep[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  vo("sidebar", [Ju, sp]);
  const ip = "[data-hover-target]",
    op = "[data-collection-image]",
    np = "data-hover-target",
    rp = "is-visible",
    ap = "is-selected";
  let lp = {};
  vo("collections-hover", [
    {
      onLoad() {
        lp[this.id] = new (class {
          init() {
            this.buttons.length &&
              this.buttons.forEach((t) => {
                t.addEventListener("mouseenter", (t) => {
                  const e = t.currentTarget.getAttribute(np);
                  this.updateState(e);
                });
              });
          }
          updateState(t) {
            const e = this.container.querySelector(`[${np}="${t}"]`),
              s = this.container.querySelector(`#${t}:not(.${rp})`),
              i = this.container.querySelector(`${ip}.${ap}`),
              o = this.container.querySelector(`${op}.${rp}`);
            s &&
              g() &&
              (null == o || o.classList.remove(rp),
              null == i || i.classList.remove(ap),
              s.classList.add(rp),
              e.classList.add(ap));
          }
          onBlockSelect(t) {
            this.updateState(t.target.id);
          }
          constructor(t) {
            (this.container = t.container),
              (this.buttons = this.container.querySelectorAll(ip)),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        lp[this.id].onBlockSelect(t);
      },
    },
    sp,
  ]);
  const cp = "[data-featured-image]",
    hp = "[data-featured-aside]",
    dp = "[data-featured-content]",
    up = "[data-featured-wrapper]",
    pp = "data-horizontal-scroll",
    mp = "data-horizontal-scroll-reversed",
    vp = {};
  vo("featured-product", [
    {
      onLoad() {
        vp[this.id] = new (class {
          init() {
            this.horizontalScroll &&
              this.imagesHolder &&
              ((this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              )),
              document.addEventListener("theme:scroll", this.scrollEvent)),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                (this.calculateHeight(),
                document.addEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                ));
          }
          scrollEvents() {
            this.requestAnimationSticky ||
              (this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              ));
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null));
          }
          calculateHorizontalPosition() {
            let t = window.scrollY + this.headerHeight;
            const e = t + window.innerHeight,
              s = this.imagesHolder.offsetTop,
              i = this.imagesHolder.offsetHeight,
              o = s + i + this.headerHeight,
              n = i - (window.innerHeight - this.headerHeight),
              r = this.horizontalScrollReversed ? 1 : -1;
            let a = 0;
            (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
              (a *= this.images.length - 1),
              this.container.style.setProperty("--translateX", a * r + "%"),
              this.lastPercent !== a
                ? (this.requestAnimationSticky = requestAnimationFrame(
                    this.calculateHorizontalPositionEvent
                  ))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.lastPercent = a);
          }
          calculateHeight() {
            let { stickyHeaderHeight: t } = a();
            this.container.style.removeProperty("--min-height"),
              this.container.style.setProperty(
                "--min-height",
                `${
                  this.wrapper.offsetHeight + this.contentHolder.offsetHeight
                }px`
              ),
              (this.headerHeight = t);
          }
          onUnload() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.removeEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                document.removeEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.horizontalScroll = this.container.hasAttribute(pp)),
              (this.horizontalScrollReversed = this.container.hasAttribute(mp)),
              (this.images = this.container.querySelectorAll(cp)),
              (this.imagesHolder = this.container.querySelector(hp)),
              (this.contentHolder = this.container.querySelector(dp)),
              (this.wrapper = this.container.querySelector(up)),
              (this.requestAnimationSticky = null),
              (this.lastPercent = 0),
              (this.scrollEvent = () => this.scrollEvents()),
              (this.calculateHorizontalPositionEvent = () =>
                this.calculateHorizontalPosition()),
              (this.calculateHeightEvent = () => this.calculateHeight()),
              this.init();
          }
        })(this);
      },
      onUnload(t) {
        vp[this.id].onUnload(t);
      },
    },
  ]);
  const gp = "[data-timeline-holder]",
    yp = "[data-timeline-rows]",
    fp = "[data-timeline-row]",
    bp = "[data-timeline-row-editor]",
    wp = "[data-timeline-button]",
    Sp = "[data-block-scroll]",
    Ep = "is-selected",
    Lp = {};
  vo("timeline", [
    {
      onLoad() {
        Lp[this.id] = new (class {
          init() {
            this.calculateRowsDimensions(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              )),
              this.isDesktopView &&
                !this.isScrollEnabled &&
                ((this.isScrollEnabled = !0),
                document.addEventListener("theme:scroll", this.scrollEvent)),
              this.rowsHolder.addEventListener("scroll", this.scrollEvent),
              document.addEventListener("theme:resize:width", this.resizeEvent),
              this.buttons.length &&
                this.buttons.forEach((t, e) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = t.currentTarget.closest(fp);
                    if (s)
                      if (g()) {
                        const t = Math.max(...this.rowsHeight),
                          s = this.holderHeight / this.rows.length,
                          i = this.holder.getBoundingClientRect().top;
                        sn((e > 0 && t < s ? s * e + i : i) + 1);
                      } else {
                        const t = 16,
                          e = s.offsetLeft - t;
                        this.rowsHolder.scrollTo({
                          left: e,
                          behavior: "smooth",
                        });
                      }
                  });
                });
          }
          resizeEvents() {
            (this.holderTop =
              this.holder.getBoundingClientRect().top + window.scrollY),
              (this.holderHeight = this.holder.offsetHeight),
              this.calculateRowsDimensions(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              ));
            const t = g();
            t && !this.isScrollEnabled
              ? ((this.isScrollEnabled = !0),
                document.addEventListener("theme:scroll", this.scrollEvent))
              : !t &&
                this.isScrollEnabled &&
                ((this.isScrollEnabled = !1),
                document.removeEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            if (!this.requestAnimation) {
              const e = t.currentTarget;
              this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition(e)
              );
            }
          }
          removeAnimationFrame() {
            this.requestAnimation &&
              (cancelAnimationFrame(this.requestAnimation),
              (this.requestAnimation = null));
          }
          calculateRowsDimensions() {
            if (this.rows.length) {
              (this.rowsHeight = []), (this.rowsWidth = 0);
              let t = 0;
              this.rows.forEach((e, s) => {
                if (
                  (this.rowsHeight.push(e.offsetHeight),
                  (this.rowsWidth +=
                    e.offsetWidth + parseInt(getComputedStyle(e).marginRight)),
                  window.Shopify.designMode)
                ) {
                  const n = this.container.querySelectorAll(bp);
                  var i, o;
                  n.length &&
                    ((t += e.offsetHeight),
                    null === (i = n[s]) ||
                      void 0 === i ||
                      i.style.setProperty(
                        "--row-height-min",
                        `${e.offsetHeight}px`
                      ),
                    null === (o = n[s + 1]) ||
                      void 0 === o ||
                      o.style.setProperty("--row-top-mobile", `${t}px`));
                }
              });
            }
          }
          calculatePosition(t = null) {
            this.removeAnimationFrame();
            const e = g(),
              s = this.holderHeight / this.rows.length;
            let i = this.holderTop;
            const o = window.innerHeight,
              n = window.scrollY + 1.5 * o;
            let r = 0;
            if (!e && t) {
              const e = t.scrollLeft - 16,
                s = t.offsetWidth;
              (r = (e / (this.rowsWidth - s)) * 100),
                this.holder.style.setProperty("--percent-mobile", `${r}%`);
            }
            (e &&
              (n < this.holderTop ||
                n > this.holderTop + this.holderHeight + o)) ||
              this.rows.forEach((t, o) => {
                if (o > 0) {
                  const o = (t.offsetLeft / this.rowsWidth) * 100;
                  let l = r > o;
                  var a;
                  e &&
                    ((l = i + s < n),
                    i - s < n &&
                      (null === (a = t.previousElementSibling) ||
                        void 0 === a ||
                        a.style.setProperty(
                          "--percent-desktop",
                          ((n - i) / s) * 100 + "%"
                        ))),
                    t.classList.toggle(Ep, l);
                }
                i += s;
              });
          }
          onUnload() {
            this.isScrollEnabled &&
              ((this.isScrollEnabled = !1),
              document.removeEventListener("theme:scroll", this.scrollEvent)),
              this.rowsHolder.removeEventListener("scroll", this.scrollEvent),
              document.removeEventListener(
                "theme:resize:width",
                this.resizeEvent
              );
          }
          onBlockSelect(t) {
            const e = this.container.querySelector(Sp);
            if (e) {
              const s = t.srcElement,
                i = [...s.parentElement.children].indexOf(s),
                o = this.rows[i];
              o &&
                e.scrollTo({ top: 0, left: o.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            (this.container = t.container),
              (this.rows = this.container.querySelectorAll(fp)),
              (this.holder = this.container.querySelector(gp)),
              this.rows.length < 2 ||
                !this.holder ||
                ((this.rowsWidth = 0),
                (this.rowsHeight = []),
                (this.holderTop =
                  this.holder.getBoundingClientRect().top + window.scrollY),
                (this.holderHeight = this.holder.offsetHeight),
                (this.buttons = this.container.querySelectorAll(wp)),
                (this.rowsHolder = this.container.querySelector(yp)),
                (this.requestAnimation = null),
                (this.isDesktopView = g()),
                (this.isScrollEnabled = !1),
                (this.scrollEvent = (t) => this.scrollEvents(t)),
                (this.resizeEvent = () => this.resizeEvents()),
                this.init());
          }
        })(this);
      },
      onUnload(t) {
        Lp[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Lp[this.id].onBlockSelect(t);
      },
    },
  ]),
    document.addEventListener("DOMContentLoaded", function () {
      go("*");
      const t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          _d({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.ScrollLock,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
);
